import {map} from 'lodash';

export const ptPT = {
    confirm: 'Confirmar',
    common: {
        replace: 'Substituir',
        remove: 'Remover',
        optional: 'Opcional',
    },
    login: {
        identifier: 'Identificador',
        password: 'Palavra-passe',
        login: 'Iniciar sessão',
        verificationCodeFromSMS: 'Código de verificação recebido por SMS',
        messageWasSentToSMS: (key, {last4digits}) => `Foi enviada uma mensagem SMS para o número de telefone terminado em ${last4digits}`,
        messageWasSentToEMAIL: (key, {maskedEmail}) => `Foi enviado um email para ${maskedEmail}`,
        checkSpamMessage: 'Se não encontrar o código de verificação, verifique a sua',
        spamFolder: 'pasta de spam',
        validate: 'Validar',
        resendCode: 'Enviar novamente',
        sendCode: 'Enviar código de verificação',
        helloX: (key, {name}) => `Olá ${name}`,
        otpDeliveryMethod: 'Como gostaria de receber o código de verificação?',
        sendBySMS: 'SMS',
        sendByEmail: 'Email',
        sendByWhatsApp: 'WhatsApp',
        messageWasSentToWhatsApp: (key, {last4digits}) => `Foi enviada uma mensagem WhatsApp para o número de telefone terminado em ${last4digits}`,
        chooseVerificationMethod: 'Escolha como gostaria de receber o código de verificação:',
        noEmailContactManager: 'o seu email não está no sistema - contacte o seu gestor para obter ajuda',
        noPhoneContactManager: 'o seu telefone não está no sistema - contacte o seu gestor para obter ajuda',
    },
    otpLogin: {
        sendToEmail: 'Email',
        sendToPhone: 'SMS',
        sendToWhatsApp: 'WhatsApp',
        emailAddress: 'Endereço de Email',
        phoneNumber: 'Número de Telefone',
        phonePlaceholder: 'Introduza o número de telefone',
        invalidPhoneNumber: 'Número de telefone inválido',
        sendVerificationCode: 'Enviar Código de Verificação',
        title: 'Iniciar sessão com Código de Verificação',
        selectCompany: 'Selecionar Empresa',
        selectCompanySubtitle: 'Está registado em várias empresas. Por favor selecione a empresa na qual pretende iniciar sessão:',
        backToContactInfo: 'Voltar às Informações de Contacto',
    },
    changePassword: {
        currentPassword: 'Palavra-passe Atual',
        password: 'Nova Palavra-passe',
        repeatPassword: 'Repetir nova palavra-passe',
        changePassword: 'Alterar Palavra-passe',
        weakPassword: 'A palavra-passe é demasiado fraca, deve conter pelo menos uma letra maiúscula, um número e ter pelo menos 8 caracteres',
        newPasswordsDoesNotMatch: 'As palavras-passe não coincidem',
        pleaseFillAllFields: 'Por favor preencha todos os campos obrigatórios'
    },
    logout: 'Terminar sessão',
    menuItems: {
        logout: 'Terminar sessão',
        changePassword: 'Alterar Palavra-passe',
        adminPanel: 'Painel de Administração',
        home: 'Página Inicial',
        myOrgs: 'As Minhas Unidades Organizacionais',
        learningCenter: 'Centro de Aprendizagem',
        users: 'Utilizadores',
        reports: 'Relatórios',
        settings: 'Definições',
        learningManagement: 'Gestão de Aprendizagem',
        filesManagement: 'Gestão de Ficheiros',
        knowledgeCenter: 'Centro de Conhecimento',
        operation: 'Operação',
        superAdmin: {
            courses: 'Gestão de Cursos',
            customers: 'Gestão de Clientes',
            organizations: 'Gestão de Unidades Organizacionais',
            users: 'Gestão de Utilizadores',
            dashboards: 'Relatórios',
            partners: 'Gestão de Parceiros',
            assets: 'Gestão de Recursos',
            courseTemplates: 'Modelos de Cursos'
        },
    },
  routingTabs: {
      featureRequiredTooltip: (key, { tabName }) => `Para ativar a funcionalidade ${tabName}, contacte o seu gestor de aprendizagem ou envie um email para info@weezbee.ai`
  },
    languages: {
        label: 'Escolher Idioma',
        languageKeys: {
            heIL: 'עברית',
            enUS: 'English',
            arIL: 'العربية',
            ruRU: 'Русский',
            ptPT: 'Português'
        }
    },
    n8nChat: {
        title: 'Buzz AI',
        subtitle: 'O seu agente de assistência WeezBee com IA',
        greeting: 'Olá, sou o Buzz AI - o seu agente de assistência WeezBee com IA. Como posso ajudá-lo?',
        newConversation: 'Nova Conversa',
        inputPlaceholder: 'Envie uma mensagem aqui...',
        closeChat: 'Fechar chat'
    },
    learningCenter: {
        title: 'O Meu Centro de Aprendizagem',
        subTitle: 'Tarefas e o seu estado de conclusão',
        loading: 'A carregar tarefas...',
        coursesToDo: 'Cursos ainda não concluídos',
        coursesCompleted: 'Cursos que concluí',
        noCoursesToDo: 'Nenhum curso ainda não concluído',
        noCoursesCompleted: 'Nenhum curso concluído',

        // Generic sign docs (keep for backward compatibility)
        signDocsToDo: 'Documentos para assinar',
        signDocsCompleted: 'Documentos que assinei',
        noSignDocsToDo: 'Nenhum documento para assinar',
        noSignDocsCompleted: 'Nenhum documento que eu tenha assinado',

        // Archived SignDocs
        archivedSignDocs: 'Tarefas Arquivadas',
        noArchivedSignDocs: 'Nenhuma tarefa arquivada',
        versionsCount: (key, { count }) => `${count} versões`,
        versions: 'Versões',
        archivedVersions: 'Versões Arquivadas',
        versionsNotFound: 'Versões não encontradas',
        versionsNotFoundDescription: 'Nenhuma versão arquivada encontrada para esta tarefa',

        // Document specific titles - READ_AND_SIGN_DOC_PDF
        pdfDocsToDo: 'Documentos para assinar',
        pdfDocsCompleted: 'Documentos que assinei',
        noPdfDocsToDo: 'Nenhum documento para assinar',
        noPdfDocsCompleted: 'Nenhum documento que eu tenha assinado',

        // WATCH_AND_SIGN_YOUTUBE_LINK & WATCH_AND_SIGN_VIMEO_LINK
        videoLinksToDo: 'Vídeos para ver',
        videoLinksCompleted: 'Vídeos que vi',
        noVideoLinksToDo: 'Nenhum vídeo para ver',
        noVideoLinksCompleted: 'Nenhum vídeo que eu tenha visto',

        // WATCH_AND_SIGN_VIDEO_FILE
        videoFilesToDo: 'Vídeos para ver',
        videoFilesCompleted: 'Vídeos que vi',
        noVideoFilesToDo: 'Nenhum vídeo para ver',
        noVideoFilesCompleted: 'Nenhum vídeo que eu tenha visto',

        // REGULAR_COURSE
        regularCoursesToDo: 'Cursos para concluir',
        regularCoursesCompleted: 'Cursos que concluí',
        noRegularCoursesToDo: 'Nenhum curso para concluir',
        noRegularCoursesCompleted: 'Nenhum curso que eu tenha concluído',

        // CANVA_PRESENTATION
        canvaPresentationsToDo: 'Apresentações para ver',
        canvaPresentationsCompleted: 'Apresentações que vi',
        noCanvaPresentationsToDo: 'Nenhuma apresentação para ver',
        noCanvaPresentationsCompleted: 'Nenhuma apresentação que eu tenha visto',

        // EXAM
        examsToDo: 'Exames ainda não concluídos',
        examsCompleted: 'Exames que concluí',
        noExamsToDo: 'Nenhum exame ainda não concluído',
        noExamsCompleted: 'Nenhum exame que eu tenha concluído',

        // LEARNING_PATH
        learningPathsToDo: 'Percursos de aprendizagem ainda não concluídos',
        learningPathsCompleted: 'Percursos de aprendizagem que concluí',
        noLearningPathsToDo: 'Nenhum percurso de aprendizagem ainda não concluído',
        noLearningPathsCompleted: 'Nenhum percurso de aprendizagem que eu tenha concluído',

        // PODCAST
        podcastsToDo: 'Podcasts para ouvir',
        podcastsCompleted: 'Podcasts que ouvi',
        noPodcastsToDo: 'Nenhum podcast para ouvir',
        noPodcastsCompleted: 'Nenhum podcast que eu tenha ouvido',

        // AUDIO_FILE
        audioFilesToDo: 'Ficheiros de áudio para ouvir',
        audioFilesCompleted: 'Ficheiros de áudio que ouvi',
        noAudioFilesToDo: 'Nenhum ficheiro de áudio para ouvir',
        noAudioFilesCompleted: 'Nenhum ficheiro de áudio que eu tenha ouvido',

        // FRONTAL_COURSE
        frontalCoursesToDo: 'Palestras presenciais para assistir',
        frontalCoursesCompleted: 'Palestras presenciais a que assisti',
        noFrontalCoursesToDo: 'Nenhuma palestra presencial para assistir',
        noFrontalCoursesCompleted: 'Nenhuma palestra presencial a que eu tenha assistido',

        // ONLINE_COURSE
        onlineCoursesToDo: 'Cursos online para concluir',
        onlineCoursesCompleted: 'Cursos online que concluí',
        noOnlineCoursesToDo: 'Nenhum curso online para concluir',
        noOnlineCoursesCompleted: 'Nenhum curso online que eu tenha concluído',

        // PRESENTATION
        presentationsToDo: 'Apresentações para ver',
        presentationsCompleted: 'Apresentações que vi',
        noPresentationsToDo: 'Nenhuma apresentação para ver',
        noPresentationsCompleted: 'Nenhuma apresentação que eu tenha visto',

        // ARTICLE
        articlesToDo: 'Artigos para ler',
        articlesCompleted: 'Artigos que li',
        noArticlesToDo: 'Nenhum artigo para ler',
        noArticlesCompleted: 'Nenhum artigo que eu tenha lido',

        // SURVEY
        surveysToDo: 'Inquéritos para preencher',
        surveysCompleted: 'Inquéritos que preenchi',
        noSurveysToDo: 'Nenhum inquérito para preencher',
        noSurveysCompleted: 'Nenhum inquérito que eu tenha preenchido',

        // LINK
        linksToDo: 'Ligações para visitar',
        linksCompleted: 'Ligações que visitei',
        noLinksToDo: 'Nenhuma ligação para visitar',
        noLinksCompleted: 'Nenhuma ligação que eu tenha visitado',

        // UPLOAD_DOCUMENT
        uploadsToDo: 'Documentos para carregar',
        uploadsCompleted: 'Documentos que carreguei',
        noUploadsToDo: 'Nenhum documento para carregar',
        noUploadsCompleted: 'Nenhum documento que eu tenha carregado',

        noOpenTasks: 'Nenhuma tarefa em aberto',

        // Existing learningCenter translations continue
        tabs: {
            myCourses: 'Os Meus Cursos',
            courses: 'Formações Presenciais e Online',
            mySignDocs: 'Documentos para Assinar',
            myTasks: 'Tarefas em Aberto',
            myCertifications: 'Certificações',
            myExams: 'Exames',
            myWeezbeeCourses: 'Cursos',
            learningPaths: 'Percursos de Aprendizagem',
            myVideos: 'Vídeos',
            myAudioFiles: 'Ficheiros de Áudio',
            myPresentations: 'Apresentações',
            myLinks: 'Ligações',
            surveys: 'Inquéritos',
            myContent: 'O Meu Conteúdo',
            archived: 'Arquivo',
        },
        searchMyContent: 'Pesquisar O Meu Conteúdo',
        searchMyContentPlaceholder: 'Pesquisar por nome...',
        filterByType: 'Filtrar por Tipo',
        uploads: 'Carregamento de Documentos',
    },
    settingsPage: {
        title: 'Definições',
        subTitle: 'Ajuste o sistema',
        subTitleBold: `às necessidades da sua empresa`,
        buttons: {
            updateLogo: "Atualizar Logótipo",
            updateOrgName: "Atualizar Nomes das Unidades Organizacionais",
            addOrg: "Adicionar Unidades Organizacionais",
            updateNotes: "Atualizar Notas para os Colaboradores",
            adminInstructionCourse: "Curso de Instrução para Administradores",
        },
        editNotesModal: {
            title: 'Editar Notas para os Colaboradores',
        },
        addOrganizationModal: {
            organizationsList: 'Lista de Unidades Organizacionais',
            useCommaSeparatedValues: 'Introduza valores separados por vírgulas, por exemplo: "Finanças, Contabilidade, Desenvolvimento de Software"',
            title: 'Adicionar Unidades Organizacionais',
        },
        editOrganizationsNames: 'Editar Nomes das Unidades Organizacionais',
        createNote: 'Criar Nova Nota',
        newNoteTitle: 'Nova Nota',
        SMSQuota: {
            title: 'Crédito de Mensagens',
            quota: 'Mensagens Adquiridas',
            sent: (key, {
                sent,
                quota
            }) => `Para sua informação, até ao momento foram enviadas ${sent} mensagens e tem ${quota} mensagens disponíveis para uso futuro`,
            lastSMSWasSentOn: (key, {date}) => `As últimas mensagens foram enviadas pelo sistema na data ${date}`,
        },
        generalSettings: {
            title: 'Geral'
        },
        reminders: {
            title: 'Lembretes',
            course: 'Curso',
            signDoc: 'Documento para Assinar',
            watchVideo: 'Ver um Vídeo',
            listenAudio: 'Ouvir Ficheiro de Áudio',
            canvaPresentation: 'Ver um Canva',
            exam: 'Exame',
            learningPath: 'Percurso de Aprendizagem',
            link: 'Ligação',
            survey: 'Inquérito',
            weezbeeCourse: 'Curso Online',
            frontalCourse: 'Curso Presencial',
            onlineCourse: 'Curso Online',
            uploadDocument: 'Carregamento de Documento',
        },
        admins: {
            title: 'Administradores',
            subTitle: 'Gestão e Definições'
        },
        setup: {
            title: 'Definições de Configuração'
        },
        deletedUsers: {
            title: 'Utilizadores Eliminados'
        },
        organizationalUnits: {
            title: 'Unidades Organizacionais',
        }
    },
    HomePage: {
        courseLegend: {
            completed: 'Concluído',
            inProgress: 'Em Progresso',
            notStarted: 'Não Iniciado'
        },
    },
    home: {
        title: 'Cursos Disponíveis para Si',
        faq: 'Perguntas Frequentes',
        welcome: 'Bem-vindo',
        // learningSubtitle:(key,{companyName}) => `לסביבת הלמידה האישית שלכם, עבור חברת ${companyName}`,
        learningSubtitle: "Para o seu ambiente de aprendizagem pessoal, para",
        userChartLabels: {
            finishedCourses: 'Cursos que concluí',
            inProgressCourses: 'Cursos em progresso',
            notStartedCourses: 'Cursos não iniciados',
            label: 'Progresso dos Cursos'
        },
        superAdmin: 'Interface do Administrador do Sistema',
    },
    faq: {
        question1: 'Posso aceder aos cursos em qualquer altura?',
        answer1: 'Sim. Pode aprender ao seu próprio ritmo, em qualquer lugar, a qualquer hora, a partir do seu telemóvel ou computador (recomendamos abrir no Google Chrome). Note que, uma vez iniciado um curso, deve concluí-lo no mesmo dispositivo.',
        question2: 'O que faço quando termino os cursos?',
        answer2: 'Quando concluir um curso, clique no botão Terminar e confirme que concluiu o curso. Certifique-se de que não existem tarefas em aberto.',
        question3: 'Precisa de ajuda?',
        answer3: 'Não hesite em contactar-nos por telefone para 052-9663062, ou por email para info@nakarmedic.co.il',
    },
    gender: {
        male: 'Masculino',
        female: 'Feminino'
    },

    OrganizationsPage: {
        title: 'As Minhas Unidades Organizacionais',
        subTitle: 'Gestão e Definições',
        organizations: 'Unidades Organizacionais que Giro',
        importUsersFile: "Importar Ficheiro de Utilizadores",
        editLogo: 'Editar Logótipo',
        dropLogoHere: 'Arraste o logótipo para aqui',
        currentLogo: 'Logótipo Atual',
        changeForAllMyOrganizations: 'Alterar para todas as Unidades Organizacionais que giro',
        logoWillBeChangedForAllOrgs: '**O logótipo será alterado para todas as unidades organizacionais sob a sua gestão',
    },
    UsersPage: {
        title: 'Utilizadores',
        subTitle: 'Gestão e Definições',
        userRowCourseMenu: {
            buttons: {
                addToCourse: 'Registar Utilizador',
                removeFromCourse: 'Remover Registo de Utilizador',
            }
        },
        userRowSignDocMenu: {
            buttons: {
                addToSignDoc: 'Registar Utilizador',
                removeFromSignDoc: 'Remover Registo',
                markCompleted: 'Marcar como Concluído',
                unmarkCompleted: 'Desmarcar como Concluído',
            },
            tooltips: {
                sessionNotToday: 'A presença só pode ser marcada no dia da sessão'
            }
        }
    },
    organizationUserTable: {
        headers: {
            name: "Nome",
            permissions: "Permissão",
            identifier: "Identificador"
        }
    },
    userType: {
        ADMIN: 'Administrador',
        USER: "Utilizador"
    },
    note: {
        title: 'Título',
        content: 'Conteúdo',
        delete: 'Eliminar Nota',
        assignToAllOrganizations: 'Atribuir a Todas as Unidades Organizacionais',
        removeFromAllOrganizations: 'Remover de Todas as Unidades Organizacionais',
        deleteNoteConfirmation: {
            title: 'Eliminar Nota',
            message: 'Tem a certeza de que pretende eliminar a nota?',
            noteName: 'Nome da Nota',
            deleteNote: 'Eliminar Nota'
        }
    },
    organization: {
        organizationName: 'Nome da Unidade Organizacional',
    },
    courseCard: {
        youAreDone: `Concluiu o curso`,
        finishBy: (key, {finishByDate}) => `Deve concluir até ${finishByDate}`,
        youAreDoneWatchAgain: 'Ver Novamente',
        goToCourse: 'Ir para o Curso'
    },
    courseProgress: {
        notStarted: 'Não Iniciado',
        inProgress: 'Em Curso',
        finished: 'Concluído!',
    },
    ReportsPage: {
        title: 'Relatórios',
        subTitle: 'Ver o estado de conclusão dos colaboradores',
        subTitleBold: 'numa apresentação gráfica.',
        courseLegend: {
            completed: 'Concluído',
            inProgress: 'Em Curso',
            notStarted: 'Não Iniciado'
        },
        coursesStats: {
            title: 'Estado de conclusão por curso',
        },
        signDocStats: {
            title: {
                course: 'Estado de conclusão por curso',
                signDocs: 'Estado de assinatura por documento'
            },
            exportToExcel: 'Exportar para Excel',
            exporting: 'A exportar...',
            exportCurrentFilters: 'Exportar filtros atuais',
            graphs: {
                usersPerformanceNumbers: (key, {taskCount = 0}) => `Número de utilizadores por estado de conclusão ${taskCount ? `(${taskCount} tarefas)` : ''}`,
                usersPerformancePercent: (key, {taskCount = 0}) => `Percentagem de utilizadores por estado de conclusão ${taskCount ? `(${taskCount} tarefas)` : ''}`,
                performanceNumberByOrg: (key, {orgsCount = 0}) => `Número de conclusões na unidade organizacional ${orgsCount ? `(${orgsCount} unidades organizacionais)` : ''}`,
                performancePercentByOrg: (key, {orgsCount = 0}) => `Percentagem de conclusão na unidade organizacional ${orgsCount ? `(${orgsCount} unidades organizacionais)` : ''}`,
                signDocsCount: ' Documentos para assinar',
                activeCourseCount: 'Itens de Aprendizagem Ativos',
                usersCount: 'Utilizadores',
                usersWithActiveTasks: 'Utilizadores com uma tarefa ativa',
                allSignDocsOfACompanyCount: 'Itens de Aprendizagem e Formação',
                examPassRate: 'Taxa de aprovação/reprovação no exame',
                examPassCountRate: 'Número de aprovações/reprovações no exame',
                info: {
                    activeCourseCount: 'Total de itens de aprendizagem com data de fim futura (cursos, documentos para assinar e tarefas de visualização)',
                    usersCount: 'Total de utilizadores',
                    usersWithActiveTasks: 'Total de utilizadores com pelo menos uma tarefa ativa',
                    allSignDocsOfACompanyCount: 'Total de itens de aprendizagem (cursos, documentos para assinar e tarefas de visualização)',
                    performanceNumberByOrg: 'Total de tarefas concluídas do total de tarefas acumuladas\n (Tarefas acumuladas = número de itens de aprendizagem e formação multiplicado pelo número de utilizadores atribuídos a cada item)',
                    performancePercentByOrg: 'Total de tarefas concluídas em cada unidade organizacional',
                    examPassRate: 'Total de utilizadores que aprovaram/reprovaram o exame do total de utilizadores que concluíram o exame',
                    examPassCountRate: 'Total de utilizadores que aprovaram/reprovaram o exame do total de utilizadores que concluíram o exame',
                }
            }
        },
        tabs: {
            dashboard: 'Painel',
            allReports: 'Relatórios de Aprendizagem e Formação',
            courses: 'Cursos',
            signDocs: 'Documentos para Assinar',
            exams: 'Exames',
            learningPaths: 'Percursos de Aprendizagem',
            surveys: 'Inquéritos',
            courseReports: 'Formações Presenciais e Online',
            userProgress: 'Progresso do Utilizador',
            certifications: 'Certificações',
            generatedReports: 'Relatórios Gerados',
            videos: 'Vídeo',
            KnowledgeCenter: 'Centro de Conhecimento',
            operation: 'Operação',
            audioFiles: 'Ficheiros de Áudio',
            presentations: 'Apresentações',
            links: 'Ligações',
        }
    },
    surveyReports: {
        title: 'Relatórios de Inquéritos',
        subtitle: (key, { count }) => `A mostrar ${count} inquéritos com dados de resposta`,
        card: {
            progress: 'Progresso',
            type: 'Tipo',
            actions: 'Ações',
            anonymous: 'Anónimo',
            identified: 'Identificado',
            viewFullReport: 'Ver Relatório',
            responseRate: 'Taxa de Resposta',
            assignedTo: 'Atribuído a Unidades Organizacionais',
            assigned: 'Atribuído',
            noOrganizations: 'Sem unidades organizacionais específicas',
        },
        noSurveys: {
            title: 'Sem inquéritos para mostrar',
            message: 'Não foram encontrados inquéritos na unidade organizacional selecionada. Tente selecionar uma unidade organizacional diferente ou crie um novo inquérito.'
        }
    },
    surveyCharts: {
        chartType: {
            bar: 'Barras',
            pie: 'Circular'
        },
        metadata: {
            totalResponses: (key, { count }) => `Total de respostas: ${count}`,
            responseFromUsers: (key, { responses }) => `${responses} respostas`,
            questionType: (key, { type }) => `Tipo de pergunta: ${type}`,
            anonymous: 'Anónimo'
        },
        noData: {
            title: 'Sem dados para mostrar para esta pergunta',
            message: 'Não foram encontradas respostas para esta pergunta'
        },
        tooltips: {
            responses: 'Respostas',
            responseCount: (key, { count }) => `${count} respostas`,
            percentage: (key, { percent }) => `${percent}%`
        }
    },
    courseReports: {
        title: 'Relatórios de Cursos',
        defaultTitle: 'Curso',
        subtitle: (key, { completed, assigned, rate }) => `${completed} de ${assigned} concluídos (${rate}%)`,
        organization: 'Unidade Organizacional',
        allOrganizations: 'Todas as Unidades Organizacionais',
        completed: 'Concluído',
        notFound: 'Curso não encontrado',
        card: {
            sessionDate: 'Data da Sessão',
            noSessionDate: 'Sem data definida',
            viewFullReport: 'Ver Relatório Completo',
            completionRate: 'Taxa de Conclusão'
        },
        downloadReport: 'Transferir Relatório de Tarefas',
        noCourses: {
            title: 'Sem Cursos Disponíveis',
            message: 'Não foram encontrados cursos para as unidades organizacionais selecionadas'
        }
    },
    signDocReports: {
        searchLabel: 'Pesquisar',
        searchPlaceholder: 'Pesquisar por nome...',
        filterByType: 'Filtrar por Tipo de Conteúdo',
        noSignDocs: {
            title: 'Sem Conteúdo Disponível',
            message: 'Não foi encontrado conteúdo para as unidades organizacionais selecionadas'
        }
    },
    surveyResults: {
        title: 'Resultados do Inquérito',
        organization: 'na unidade organizacional',
        allOrganizations: 'em todas as unidades organizacionais',
        subtitle: (key, { responses, assigned, rate }) => `${responses} de ${assigned} responderam (${rate}%)`,
        backToSurveys: 'Voltar à lista de inquéritos',
        questionsTitle: 'Resultados das Perguntas',
        questionNumber: (key, { number }) => `Pergunta ${number}`,
        freeTextDefault: (key, { count }) => `Recebidas ${count} respostas de texto livre`,
        notFound: 'Inquérito não encontrado',
        defaultTitle: 'Resultados do Inquérito',
        freeTextResponses: {
            title: 'Respostas de Texto Livre',
            noResponses: 'Não foram recebidas respostas de texto livre para esta pergunta'
        },
        meta: {
            organization: 'Unidade Organizacional',
            totalQuestions: 'Número de Perguntas',
            type: 'Tipo de Inquérito',
            completionRate: 'Taxa de Conclusão'
        },
        tabs: {
            results: 'Resultados do Inquérito',
            users: 'Utilizadores',
            generatedReports: 'Relatórios Gerados',
            KnowledgeCenter: 'Centro de Conhecimento'
        }
    },
    learningPathReport: {
        status: {
            completed: 'Concluído',
            inProgress: 'Em Progresso',
            notStarted: 'Não Iniciado'
        }
    },
    surveyUsers: {
        columns: {
            fullName: 'Nome Completo',
            firstName: 'Primeiro Nome',
            lastName: 'Apelido',
            identifier: 'Identificador',
            status: 'Estado',
            idNumber: 'Número de Identificação',
            employeeId: 'ID de Colaborador',
            showUserAnswer: 'Mostrar Respostas'
        },
        actions: {
            showAnswer: 'Mostrar Respostas'
        },
        noUsers: {
            title: 'Sem utilizadores para mostrar',
            message: 'Não foram encontrados utilizadores para o inquérito na unidade organizacional selecionada.'
        }
    },
    userSurveyAnswers: {
        modalTitle: (key, { userName }) => `Respostas do utilizador ${userName}`,
        columns: {
            question: 'Pergunta',
            questionType: 'Tipo de Pergunta',
            userAnswer: 'Resposta do Utilizador',
            isCorrect: 'Correto'
        },
        notApplicable: 'Não aplicável',
        noAnswer: 'Sem resposta',
        unknownQuestion: 'Pergunta desconhecida',
        unknownQuestionType: 'Tipo de pergunta desconhecido',
        unknownOption: 'Opção desconhecida',
        invalidRating: 'Classificação inválida',
        loading: 'A carregar respostas...',
        error: 'Erro ao carregar respostas',
        noQuestions: 'Não foram encontradas perguntas'
    },
    courseProgressMgmnt: {
        notStarted: 'Não Iniciado',
        inProgress: 'Em Progresso',
        finished: 'Concluído',
        attended: 'Presente',
        noShow: 'Ausente',
        registered: 'Registado',
        completedOn: 'Data de Assinatura: ',
        completedOnCourse: 'Data de Conclusão: ',
        by: 'por ',
        manual: 'Manual',
        finishBy: 'A concluir até: ',
        score: 'Pontuação',
    },
    examScore: 'Pontuação',
    LearningManagementPage: {
        title: 'Gestão da Aprendizagem',
        subTitle: 'Adicionar, editar e eliminar',
        addCourse: 'Adicionar Curso',
        editCourse: 'Editar Curso',
        deleteCourse: 'Eliminar Curso',
        courseName: 'Nome do Curso',
        courseDescription: 'Descrição do Curso',
        courseImage: 'Imagem do Curso',
        createKnowledgeSource: 'Criar Fonte de Conhecimento',
        createQuestionnaire: 'Criar questionário',
        createExam: 'Criar um Exame',
        createLearningPath: 'Criar Percurso de Aprendizagem',
        courseCard: {
            editCourse: 'Editar Curso',
        },
        signDocCard: {
            editSignDoc: {
                READ_AND_SIGN_DOC_PDF: 'Editar Documento',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'Editar Tarefa de Visualização',
                WATCH_AND_SIGN_VIMEO_LINK: 'Editar Tarefa de Visualização',
                WATCH_AND_SIGN_VIDEO_FILE: 'Editar Tarefa de Visualização',
                AUDIO_FILE: 'Editar Tarefa de Audição',
                REGULAR_COURSE: 'Editar Curso',
                CANVA_PRESENTATION: 'Editar Apresentação',
                EXAM: 'Editar exame',
                LEARNING_PATH: 'Editar Percurso de Aprendizagem',
                LINK: 'Editar Ligação para Visualização',
                SURVEY: 'Editar Inquérito',
                FRONTAL_COURSE: 'Editar Aula Presencial',
                ONLINE_COURSE: 'Editar Curso Online',
            },
            deleteModal: {
                title: 'Eliminar Documento',
                text: 'Tem a certeza de que pretende eliminar este documento? Esta ação não pode ser anulada',
                confirm: 'Eliminar Documento',
                cancel: 'Cancelar',
                signDocName: 'Nome do Documento',
                deleteAllVersionsCheckbox: 'Eliminar todas as versões deste documento',
                warningAllVersions: '⚠️ Aviso: Eliminar este documento irá eliminar todas as versões do documento'
            },
            versionManagement: 'Gestão de Versões',
            uplodingSignDoc: {
                uploadInProgress: 'Carregamento de ficheiro em curso',
                uploadFailed: 'O processo de carregamento falhou'
            }
        },
        users: {
            buttons: {
                downloadCsv: 'Transferir',
                downloadCsvForOrganizations: 'Transferir relatório de tarefas para utilizadores das unidades organizacionais selecionadas',
                downloadUserDetailsForOrganizations: 'Transferir ficheiro de detalhes de utilizadores para unidades organizacionais selecionadas',
                downloadSelectedUsers: 'Transferir Relatório de Tarefas para Utilizadores Selecionados',
                downloadCsvForOrganization: 'Transferir ficheiro de utilizadores para a unidade organizacional selecionada',
                downloadCsvForAllOrganizations: 'Transferir ficheiro de utilizadores para todas as unidades organizacionais que giro',
            },
            messages: {
                exportStarted: 'Exportação iniciada. A navegar para Relatórios...',
                exportFailed: 'A exportação falhou. Tente novamente.',
                noUsersSelected: 'Selecione utilizadores para exportar',
            }
        },
        courseManagement: 'Gestão de Cursos',
        signDocManagement: 'Gestão de Documentos',
        noSignDocs: 'Sem documentos para apresentar',
        noSearchResults: 'Nenhum resultado encontrado para a sua pesquisa',
        noSearchResultsHint: 'Tente ajustar o termo de pesquisa ou limpe a pesquisa para ver todos os itens',
        tabs: {
            signDocs: 'Documentos para Assinar',
            courses: 'Cursos',
            users: 'Utilizadores',
            certifications: 'Certificações',
            pendingApprovals: 'Documentos para Aprovação',
            courseAttendance: 'Presença em Curso',
            tasks: 'Tarefas',
            knowledgeCenter: 'Centro de Conhecimento',
            operation: 'Operação',
            exams: 'Exames',
            learningPath: 'Percursos de Aprendizagem/ Formação',
            videoLinks: 'Vídeos',
            audioFiles: 'Ficheiros de Áudio',
            presentations: 'Apresentações',
            links: 'Ligações',
            surveys: 'Inquéritos',
            uploads: 'Carregar Documentos',
            frontalCourses: 'Aulas Presenciais',
            onlineCourses: 'Cursos Online',
            archive: 'Arquivo',
        },
        searchTasks: 'Pesquisar Tarefas',
        searchTasksPlaceholder: 'Pesquisar por nome...',
        filterByType: 'Filtrar por Tipo',
        filterByTypePlaceholder: 'Selecionar tipos...',
        allTypes: 'Todos os Tipos',
        typeNames: {
            READ_AND_SIGN_DOC_PDF: 'Documentos para Assinar',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Vídeos',
            WATCH_AND_SIGN_VIMEO_LINK: 'Vídeos',
            WATCH_AND_SIGN_VIDEO_FILE: 'Vídeos',
            VIDEOS: 'Vídeos',
            REGULAR_COURSE: 'Cursos',
            CANVA_PRESENTATION: 'Apresentações',
            EXAM: 'Exames',
            LEARNING_PATH: 'Percursos de Aprendizagem',
            SURVEY: 'Inquéritos',
            ARTICLE: 'Artigos',
            AUDIO_FILE: 'Ficheiros de Áudio',
            LINK: 'Ligações',
            PODCAST: 'Podcasts',
            FRONTAL_COURSE: 'Cursos Presenciais',
            ONLINE_COURSE: 'Cursos Online',
            PRESENTATION: 'Apresentações',
            WEEZBEE_COURSE: 'Cursos',
            UPLOAD_DOCUMENT: 'Carregar Documentos',
        },
        addLearningObject: 'Adicionar Itens de Aprendizagem \ne Formação',
        honeycombTitle: 'Itens de Aprendizagem e Formação',
    },
    signDocVersionManagement: {
        title: 'Gestão de Versões',
        managingVersionsFor: 'Gerir versões para',
        createNewVersionButton: 'Criar Nova Versão',
        allVersions: 'Todas as Versões',
        archive: 'Arquivo',
        currentVersion: 'Versão Atual',
        versionNumber: 'Número de Versão',
        versionDetails: 'Detalhes da Versão',
        viewDetails: 'Ver Detalhes',
        errorTitle: 'Erro ao Carregar Versões',
        notFound: 'Documento Não Encontrado',
        notFoundDescription: 'O documento que procura não existe ou foi removido',
        noVersions: 'Nenhuma versão para apresentar',
        created: 'Criado',
        createdBy: 'Criado por',
        expiredAt: 'Expirou em',
        type: 'Tipo',
        status: {
            label: 'Estado',
            ACTIVE: 'Ativo',
            ARCHIVED: 'Arquivado',
            SCHEDULED: 'Agendado'
        },
        toggleStatus: 'Clique para alternar o estado (Ativo/Arquivado)',
        stats: {
            assigned: 'Atribuído',
            completed: 'Concluído',
            inProgress: 'Em Progresso',
            completionRate: 'Taxa de Conclusão',
            totalUsers: 'Total de Utilizadores'
        },
        statistics: {
            progressDone: 'Progresso Concluído',
            usersAssigned: 'Utilizadores Atribuídos',
            usersCompleted: 'Utilizadores que Concluíram',
            usersInProgress: 'Utilizadores em Progresso'
        },
        viewStatistics: 'Ver Estatísticas',
        userStatistics: 'Estatísticas de Utilizadores',
        returnToData: 'Voltar aos Dados',
        goToReports: 'Ir para Relatórios',
        edit: 'Editar',
        preview: 'Pré-visualizar',
        tabs: {
            versions: 'Versões',
            recurringDetails: 'Detalhes de Recorrência'
        },
        recurring: {
            title: 'Configuração de Recorrência',
            notConfigured: 'Este documento não está configurado para recorrência',
            frequency: 'Frequência de Recorrência',
            nextVersionDate: 'Data da Próxima Versão',
            editNextVersionDate: 'Editar data da próxima versão',
            changeDate: 'Alterar data',
            everyXMonths: (key, { value }) => `De ${value} em ${value} ${value === 1 ? 'mês' : 'meses'}`,
            everyXYears: (key, { value }) => `De ${value} em ${value} ${value === 1 ? 'ano' : 'anos'}`,
            badge: 'Recorrente',
        }
    },
    signDocPreviewPage: {
        title: 'Pré-visualização de Conteúdo',
        loading: 'A carregar pré-visualização...',
        errorTitle: 'Erro de Pré-visualização',
        errorDescription: 'Não é possível carregar a pré-visualização do conteúdo. O documento pode ainda não ter conteúdo carregado.',
        noContent: 'Não existe conteúdo pré-visualizável disponível para este documento.',
        backToVersions: 'Voltar às Versões',
    },
    editCourseModal: {
        title: 'Editar Curso',
        courseName: 'Nome do Curso',
        courseDescription: 'Descrição do Curso',
        courseImage: 'Imagem do Curso',
        save: 'Guardar Alterações',
        edit: {
            courseName: 'Nome do Curso',
            courseDescription: 'Descrição do Curso',
            dateEditNotification: 'Pode definir uma data de fim unificada para todos os utilizadores inscritos no curso em todas as unidades organizacionais que gere. Quaisquer alterações feitas aqui substituirão as alterações individuais feitas para os utilizadores.'
        },
        dateModal: {
            title: 'Definir Data de Fim',
            timeAndTimezone: 'Até às 00:00 no fuso horário: '
        }
    },
    editUserCourseModal: {
        title: (key, {userName, courseName}) => `Definir uma data de fim para o curso "${courseName}" para o utilizador "${userName}"`,
        dateEditNotification: 'Pode definir uma data de fim para o utilizador. Esta alteração permanecerá em vigor a menos que altere a data de fim para toda a unidade organizacional.'
    },
    AppSideMenu: {
        welcome: `Bem-vindo`,
        legalLinks: {
            termsOfUse: 'Termos de Utilização',
            privacyPolicy: 'Política de Privacidade'
        }
    },
    superAdmin: {
        partnersTable: {
            columns: {
                clientSecretExpiresAt: 'Expiração do Client Secret',
            }
        },
        cronJobs: {
            sectionTitle: 'Cron Jobs',
            runRecurringRenewal: 'Executar Renovação Recorrente',
            running: 'A executar...',
            renewalSuccess: 'Renovação recorrente concluída com sucesso',
            renewalError: 'Falha na renovação recorrente. Verifique os registos do servidor.',
        },
        generateAPIKeyModal: {
            generateAPIKey: 'Gerar Chave API',
            modalTitle: 'Chave API',
        },
        generateClientCreds: {
            generateClientCreds: 'Gerar Credenciais de Cliente',
            modalTitle: 'Credenciais de Cliente',
            clientId: 'ID de Cliente',
            clientSecret: 'Segredo de Cliente'
        },
        editPartnerCompaniesModal: {
            modalTitle: 'Editar Empresas Parceiras',
            selectAllCompanies: 'Selecionar Todas as Empresas',
            selectCompanies: 'Selecionar Empresas',
            save: 'Guardar Empresas'
        },
        assets: {
            title: 'Gestão de Recursos',
            columns: {
                fileName: 'Nome do Ficheiro',
                type: 'Tipo',
                company: 'Empresa',
                createdBy: 'Criado Por',
                tags: 'Etiquetas',
                lastModified: 'Última Modificação',
                download: 'Transferir',
                thumbnail: 'Pré-visualização'
            },
            filters: {
                companyName: 'Nome da Empresa',
                type: 'Tipo de Ficheiro',
                all: 'Todos',
                image: 'Imagem',
                video: 'Vídeo',
                clear: 'Limpar Filtros',
                generalBank: 'Banco Geral'
            },
            fileTypes: {
                image: 'Imagem',
                video: 'Vídeo',
                file: 'Ficheiro'
            },
            download: 'Transferir Ficheiro',
            downloadError: 'Erro ao transferir o ficheiro',
            loading: 'A carregar...',
            thumbnailError: 'Erro ao carregar pré-visualização',
            thumbnail: 'Pré-visualização do ficheiro',
            upload: {
                title: 'Carregar para o Banco Geral',
                uploadButton: 'Carregar Recurso',
                cancel: 'Cancelar',
                upload: 'Carregar',
                dragDrop: 'Arraste e largue um ficheiro aqui ou clique para selecionar um ficheiro',
                supportedTypes: 'Tipos de ficheiro suportados: Imagens (.jpg, .png, .gif) e Vídeos (.mp4, .mov, .avi)',
                presentationName: 'Nome de Apresentação',
                presentationNamePlaceholder: 'Introduza um nome para o ficheiro',
                description: 'Descrição',
                descriptionPlaceholder: 'Introduza uma descrição para o ficheiro',
                noFileSelected: 'Por favor selecione um ficheiro para carregar',
                error: 'Ocorreu um erro ao carregar o ficheiro',
                uploading: 'A carregar'
            },
            tags: {
                editTags: 'Editar Etiquetas',
                enterTagsPlaceholder: 'Introduza etiquetas separadas por vírgulas',
                tagsHelperText: 'As etiquetas ajudam a organizar e encontrar recursos mais facilmente',
                andMoreTags: (key, { count }) => `e mais ${count}`,
                noTags: 'Sem etiquetas',
                save: 'Guardar',
                cancel: 'Cancelar'
            }
        },
        courseTemplates: {
            title: 'Modelos de Curso',
            placeholder: 'A funcionalidade de modelos de curso estará disponível em breve. Esta página permitirá criar, editar e gerir modelos de curso que podem ser utilizados em toda a plataforma.',
            columns: {
                templateName: 'Nome do Modelo',
                templateSubject: 'Assunto',
                description: 'Descrição',
                createdBy: 'Criado Por',
                isPubliclyAccessible: 'Acessível Publicamente',
                isReady: 'Pronto',
                actions: 'Ações'
            },
            buttons: {
                createTemplate: 'Criar Novo Modelo',
                editTemplate: 'Editar Modelo',
                duplicateTemplate: 'Duplicar Modelo',
                deleteTemplate: 'Eliminar Modelo',
                viewTemplate: 'Ver Modelo'
            },
            searchPlaceholder: 'Pesquisar modelos...',
            noTemplates: 'Nenhum modelo encontrado. Crie o seu primeiro modelo clicando no botão acima.',
            fetchError: 'Falha ao carregar modelos. Por favor tente novamente mais tarde.',
            searchError: 'Falha ao pesquisar modelos. Por favor tente novamente mais tarde.',
            deleteError: 'Falha ao eliminar modelo. Por favor tente novamente mais tarde.',
            confirmDelete: 'Tem a certeza que pretende eliminar este modelo?'
        },
        editFFModal: {
            modalTitle: "Editar Funcionalidades da Empresa",
            editFeatures: "Editar Funcionalidades",
            paths: {
                basic: 'Básico',
                creator: 'Criador',
                enterprise: 'Enterprise'
            },
            deals: {
                messaging: 'Mensagens e Comunicação',
                contentTypes: 'Tipos de Conteúdo',
                courses: 'Cursos e Formação',
                automation: 'Automatização',
                advanced: 'Funcionalidades Avançadas',
                organization: 'Gestão Organizacional',
                system: 'Definições do Sistema'
            },
            dealStatus: {
                allEnabled: 'Tudo Ativado',
                partiallyEnabled: 'Parcialmente Ativado',
                disabled: 'Desativado'
            },
            featureFlags: {
                automationFF: 'Automatização',
                smsFF: 'SMS',
                whatsappFF: 'Whatsapp',
                emailFF: 'Email',
                signDocsFF: 'Tarefas',
                sendWelcomeMessageFF: 'Enviar Mensagens a Novos Utilizadores',
                signDocsReadAndSignDocPdfFF: 'Assinar PDF',
                signDocsWatchAndSignYoutubeLinkFF: 'Confirmar Visualização no Youtube',
                signDocsWatchAndSignVimeoLinkFF: 'Confirmar Visualização no Vimeo',
                signDocsWatchAndSignVideoFileFF: 'Confirmar Visualização de Ficheiro de Vídeo',
                signDocCanvaPresentationFF: 'Apresentação Canva',
                regularCourseFF: 'Cursos',
                frontalCourseFF: 'Formações Presenciais',
                onlineCourseFF: 'Formações Online',
                notifyNewTaskToUserFF: 'Notificar Utilizador de Nova Tarefa',
                knowledgeCenterFF: 'Centro de Conhecimento',
                orgAdminMgmtFF: 'Gestão de Permissões de Administrador',
                subAdminCanCreateOrgFF: 'Sub-Administrador Pode Criar Unidades Organizacionais',
                languagesFF:'Idiomas',
                examsFF: 'Exames',
                AIFF: 'IA',
                learningPathFF: 'Percurso de Aprendizagem',
                signDocsAudioFileFF: 'Ficheiro de Áudio',
                linkFF: 'Ligações',
                surveyFF: 'Inquéritos',
                recurringAutomationFF: 'Automatização Recorrente',
                weezbeeCourseFF: 'Curso WeezBee',
                uploadDocumentFF: 'Carregar Documentos',
                certificationFF: 'Certificações',
                phoneE164MigrationFF: 'Migração de Telefone para Formato E.164',
                bulkUserRefactorFF: 'Refatoração em Massa de Utilizadores V2',
                operationModeFF: 'Modo de Operação (Renomear Centro de Conhecimento)',
                mustDoComplianceFF: 'Conformidade Obrigatória'
            }
        },
        allUsersTable: {
            columns: {
                firstName: 'Primeiro Nome',
                lastName: 'Último Nome',
                email: 'Email',
                phone: 'Telefone',
                roles: 'Funções',
                identifier: 'Identificador',
                organization: 'Unidade Organizacional',
                id: 'ID',
                companyName: 'Empresa',
                yes: 'Sim',
                no: 'Não',
                isSuperAdmin: 'Administrador do Sistema',
                isCompanyAdmin: 'Administrador da Empresa',
                isDeleted: 'Eliminado',
                deleted: 'Eliminado',
                edit: 'Editar',
                permanentlyDelete: 'Eliminação Permanente',
                loginUrl: 'Ligação de Início de Sessão',
                userCreatedSmsDate: 'Data do SMS de Boas-Vindas',
                loginAs: 'Iniciar Sessão Como',
            },
            buttons: {
                downloadCsvForOrganization: 'Transferir ficheiro Excel para a unidade organizacional',
                downloadCsvForAllOrganizations: 'Transferir ficheiros Excel para todas as unidades organizacionais que giro',
                downloadCsvForOrganizationSuccess: 'Os seus ficheiros estarão prontos para transferência em breve em "Menu -> Gestão de Ficheiros"',
                deleteUsers: 'Eliminar Utilizadores',
                edit: 'Editar',
            }
        },
        allOrgsTable: {
            columns: {
                orgName: 'Nome da Unidade Organizacional',
                taxIdentifier: 'Identificador',
                companyId: 'ID da Empresa',
                orgAddress: 'Morada',
                orgContactInfo: 'Informação de Contacto',
                id: 'ID',
                companyName: 'Nome da Empresa',
                delete: 'Eliminar',
            },
            deleteOrg: 'Eliminar Unidade Organizacional',
            deleteOrgTitle: 'Eliminar Unidade Organizacional: ',
            deleteOrgText: 'Tem a certeza de que pretende eliminar a unidade organizacional',
            deleteOrgConfirm: 'Eliminar Unidade Organizacional',
        },
        createNewCourse: {
            title: 'Criar um Novo Curso',
            docName: 'Nome do Curso',
            courseDescription: 'Descrição do Curso',
            create: 'Criar Curso',
            companyName: 'Nome da Empresa',
            dropZipHere: 'Arraste o ficheiro zip do curso para aqui ou clique para selecionar um ficheiro',
            modalTitle: 'Criar um Novo Curso',
            assignToAllOrganizations: 'Atribuir a Todas as Unidades Organizacionais',
            assigned: 'Atribuído com sucesso a todas as unidades organizacionais',
            organizationsTable: {
                orgName: 'Nome da Unidade Organizacional',
                addOrganization: 'Adicionar Curso à Unidade Organizacional',
                removeOrganization: 'Remover Curso da Unidade Organizacional',
                onlyOneCompanyPerCourse: 'Um curso só pode ser adicionado a uma empresa, pelo que não pode alterar a seleção de empresa agora',
            }
        },

        createNewCustomer: {
            modalTitle: 'Criar um Novo Cliente',
            companyName: 'Nome da Empresa',
            userPrefix: 'Prefixo do Utilizador (único para cada empresa - apenas em inglês)',
            identifier: 'Identificador',
            contactEmail: 'Email de Contacto',
            contactName: 'Nome de Contacto',
            contactPhone: 'Telefone de Contacto',
            userCreationTitle: 'Criar um utilizador inicial da empresa',
            detailsTitle: 'Preencha os detalhes da empresa',
            userPassword: 'Palavra-passe do utilizador (apenas em inglês)',
            userIdentifier: 'Identificador do utilizador (apenas em inglês)',
            createCompany: 'Criar Empresa',
            userNameNoteNoPrefix: '*Deve introduzir um prefixo de utilizador antes de poder introduzir um nome de utilizador',
            userNameNote: (key, {companyUsersPrefix, userIdentifier}) => {
                return '*O nome de utilizador real que será criado é: ' + companyUsersPrefix + "-" + (userIdentifier || '"Identificador do Utilizador"')
            },
            userPrefixError: 'O prefixo do utilizador deve estar apenas em inglês',
            userFirstName: 'Primeiro Nome',
            userLastName: 'Apelido',
            contactFirstName: 'Primeiro Nome do Contacto',
            contactLastName: 'Apelido do Contacto',
            countryCode: 'País',
        },
        editCourse: {
            courseName: 'Nome do Curso',
            docName: 'Nome do Curso',
            courseDescription: 'Descrição do Curso',
            description: 'Descrição do Curso',
            companyName: 'Nome da Empresa',
            dropZipHere: 'Arraste o ficheiro zip do curso para aqui ou clique para selecionar um ficheiro',
            dropZipNote: '**Note que está no modo de edição, pelo que se já existir um ficheiro zip para este curso, carregar outro ficheiro substituirá o existente**',
            saveChanges: 'Guardar Alterações',
            modalTitle: 'Editar Curso',
        },
        editCustomer: {
            modalTitle: 'Editar Cliente',
            adminUserDetails: 'Detalhes do Utilizador Principal',
            detailsTitle: 'Editar Detalhes da Empresa',
            organizationsTitle: `Unidades Organizacionais do Cliente`,
            addOrganizations: 'Adicionar Unidades Organizacionais ao Cliente',
            addOrganizationModal: {
                organizationsList: 'Lista de Unidades Organizacionais',
                useCommaSeparatedValues: 'Introduza valores separados por vírgulas, por exemplo: "Finanças, Contabilidade, Desenvolvimento de Software"',
                title: 'Adicionar Unidades Organizacionais ao Cliente',
            },
            mfaForAllUsers: 'Exigir MFA para todos os utilizadores da empresa',
        },
        coursesTable: {
            columns: {
                courseName: 'Nome da Tarefa',
                description: 'Descrição da Tarefa',
                edit: 'Editar',
                type: 'Tipo de Tarefa',
                editCourse: 'Editar Curso',
                companyName: 'Nome da Empresa',
                remove: 'Eliminar',
                uploadStatus: 'Estado do Carregamento',
            },
            uploadStatus: {
                READY: 'Pronto',
                UPLOADING: 'A carregar...',
                FAILED: 'Falhou',
            }
        },
        customersTable: {
            downloadReport: 'Transferir Relatório de Empresas',
            downloadingReport: 'A transferir relatório...',
            reportGenerated: 'Relatório Gerado com Sucesso',
            reportError: 'Erro ao Gerar Relatório',
            columns: {
                companyName: 'Nome da Empresa',
                taxIdentifier: 'Identificador',
                edit: 'Editar',
                editCompany: 'Editar Empresa',
                smsQuota: 'Crédito de Mensagens',
                userQuota: 'Quota de Utilizadores',
                activeUsers: 'Utilizadores Ativos',
                featureFlags: 'Funcionalidades',
                storageQuotaMB: 'Armazenamento (MB)',
                editQuota: 'Editar Quotas',
                welcomeMessage: 'Enviar Mensagem de Boas-Vindas',
                welcomeMessageSent: 'Mensagem Enviada',
                loginAs: 'Iniciar Sessão Como',
            },
            welcomeMessage: {
                confirmTitle: 'Enviar Mensagem de Boas-Vindas a',
                confirmMessage: 'Tem a certeza de que pretende enviar mensagens de boas-vindas a todos os utilizadores desta empresa?',
                detailsTitle: 'Detalhes da Mensagem de Boas-Vindas',
                sentDate: 'Data de Envio:',
                sentBy: 'Enviado Por:',
                company: 'Empresa:'
            },
            quota: {
                editQuota: 'Editar Quotas',
                editQuotaTitle: 'Editar Quotas para a Empresa',
                editCredits: 'Editar Créditos',
                editUserQuota: 'Quota de Utilizadores',
                MessagesCreditsToEdit: 'Créditos de Mensagens',
                storageQuotaToEdit: 'Armazenamento em MB',
            }
        },
        createNewPartner: {
            modalTitle: 'Criar Novo Parceiro',
            identifier: 'Identificador',
            partnerName: 'Nome do Parceiro',
            contactEmail: 'Email de Contacto',
            contactPhone: 'Telefone de Contacto',
            contactFirstName: 'Primeiro Nome do Contacto',
            contactLastName: 'Apelido do Contacto',
            createPartner: 'Criar Parceiro',
            detailsTitle: 'Preencha os detalhes do parceiro',
            clientId: 'ID do Cliente',
            clientSecret: 'Segredo do Cliente',
        }
    },
    dataGrid: {
        filters: {
            search: {
                input: 'Pesquisar',
            },
        },
        filterLabels: {
            course: 'Curso',
            organization: 'Unidade Organizacional',
            company: 'Empresa',
            signDoc: 'Tarefas',
            fileType: 'Tipo de Ficheiro'
        },
        footer: {
            rowsSelected: (key, {count}) => count === 1 ? '1 linha selecionada' : `${count} linhas selecionadas`
        }
    },
    importUsersPage: {
        downloadExample: 'Transferir um Ficheiro de Modelo para Criar Utilizadores',
        downloadUsersAsCSV: 'Transferir Utilizadores como Ficheiro CSV',
    },
    importUsersModal: {
        title: 'Importar / Editar Utilizadores e Unidades',
        tabs: {
            importUsers: {
                title: 'Importar Utilizadores e Adicionar Unidades',
            },
            reorganizeUsers: {
                title: 'Importar Utilizadores e Alterar Unidades',
            }
        },
        manyUsersMessage: 'Parece que há muitos utilizadores no ficheiro; a importação pode demorar vários minutos. Após clicar em Criar, mantenha a janela aberta até o carregamento estar concluído e aguarde mais alguns minutos para que todas as alterações sejam refletidas no sistema.',
        users: {
            firstName: 'Nome Próprio',
            lastName: 'Apelido',
            phone: 'Telefone',
            email: 'Email',
            idNumber: 'Número de Identificação',
            employeeId: 'ID de Funcionário',
            organizations: 'Unidades Organizacionais',
            // Additional aliases for Excel header matching (used by getAllTranslationsForSubKeys)
            organizationsAliases: ['Organizations', 'Organization', 'Units', 'Unit', 'Org', 'Orgs'],
        },
        createUsers: 'Criar/Editar Utilizadores',
        selectOrganization: 'Selecionar unidades organizacionais para as quais os utilizadores serão criados',
        selectOrganizationsToAdd: 'Selecionar unidades organizacionais a adicionar',
        organization: 'Unidade Organizacional',
        newUsersWillBeCreatedAndOrganizationsWillBeAddedToAllUsers: 'As unidades organizacionais serão adicionadas a todos os utilizadores encontrados no ficheiro anexado. Os utilizadores que não existirem serão criados; os utilizadores existentes serão atualizados.',
        newUsersWillBeCreatedAndOrganizationsWillBeOverride: 'As unidades organizacionais serão alteradas para todos os utilizadores no ficheiro anexado (os utilizadores serão removidos das unidades que não estiverem selecionadas). Os utilizadores que não existirem serão criados; os utilizadores existentes serão atualizados.',
        errors: {
            missingMandatoryField: (key, {row}) => `*Campos obrigatórios em falta na linha ${row}:`,
            twoSourcesForOrgs: 'Não é possível selecionar unidades organizacionais de ambas as fontes. Por favor, remova as unidades organizacionais do ficheiro importado ou da seleção no topo da página',
            removeOrgsFromFile: 'Por favor, remova as unidades organizacionais do ficheiro importado',
            missingSourceForOrgs: 'Nenhuma unidade organizacional selecionada para os utilizadores. Por favor, escolha unidades no topo da página ou adicione-as no ficheiro de modelo de importação.',
            missingSourceForOrgsSelectFromMultiSelect: 'Nenhuma unidade organizacional selecionada para os utilizadores. Por favor, escolha unidades na seleção no topo da página.',
            noFirstNameColumn: 'O ficheiro deve incluir uma coluna com o nome "First Name"',
            noLastNameColumn: 'O ficheiro deve incluir uma coluna com o nome "Last Name"',
            emptyExcelFile: 'O ficheiro Excel está vazio ou não contém uma folha de cálculo',
            invalidExcelFile: 'O ficheiro Excel está corrompido ou é inválido; por favor, verifique o ficheiro e tente novamente',
            unsupportedFileType: 'O tipo de ficheiro não é suportado. Por favor, carregue um ficheiro CSV ou Excel (.xlsx, .xls)',
            missingColumn: (key, {columnName}) => `O ficheiro deve incluir uma coluna com o nome "${columnName}"`,
        }
    },
    uploadBox: {
        uploading: 'A carregar ficheiro...',
        uploaded: 'Ficheiro carregado com sucesso',
        uploadFailed: 'O ficheiro é inválido. Por favor, verifique se o tamanho e o tipo de ficheiro não excedem o limite permitido.',
        maxFileSize: (key, {maxFileSize}) => `O tamanho máximo permitido para o ficheiro é ${maxFileSize}`,
        onlyFileTypes: (key, {fileTypes}) => `Os tipos de ficheiro permitidos para carregamento são: ${map(fileTypes, fileType => `${fileType}`).join(', ')}`,
    },
    completedCoursePage: {
        title: 'Conclusão do Curso',
        subTitle: 'Por favor, confirme que terminou o curso',
        buttons: {
            confirmCourseCompletion: 'Confirmo que terminei o curso'
        },
        finishedSuccessfully: 'Concluiu o curso com sucesso',
        oops: 'Ups...',
        youGotLost: 'Parece que se perdeu; navegue através do menu',
        courseCompletedSuccessfullyPopup: 'Concluiu o curso com sucesso',
    },
    errors: {
        clientError: 'Erro nos detalhes fornecidos',
        serverError: 'Erro no pedido ao servidor',
        generalServerError: 'Erro geral no pedido ao servidor; tente recarregar a página. Se o problema persistir, contacte o suporte técnico.',
        notFound: 'Recurso não encontrado',
        forbidden: 'Não tem permissão para aceder a este recurso',
        privateRouteUserNotLoggedIn: 'O utilizador não tem sessão iniciada, pelo que o conteúdo não pode ser visualizado. Por favor, inicie sessão e tente novamente.',
        session_expired: 'A sua sessão expirou. Por favor, inicie sessão novamente para continuar.',
        too_many_requests: 'Erro: tentou demasiadas vezes; por favor, tente novamente mais tarde',
        noAdminUserFound: 'Nenhum utilizador administrador encontrado para esta empresa',
        popupBlocked: 'Janela pop-up bloqueada. Por favor, permita janelas pop-up para este site.',
        failedToGenerateLoginUrl: 'Falha ao gerar o URL de início de sessão',
        userNotFound: 'Utilizador não encontrado',
    },
    alertDialog: {
        ok: 'OK',
        cancel: 'Cancelar',
    },
    orphanedUsers: {
        filterLabel: 'Sem organização',
        alertMessage: 'utilizadores ativos não estão associados a nenhuma organização. Para corrigir: selecione "Sem organização" no filtro, depois clique em Editar em cada utilizador e atribua uma organização.',
    },
    createEditUserModal: {
        editPhone: 'Editar telefone',
        organizationsLabel: 'Unidades organizacionais',
        selectAllOrganizations: 'Selecionar todas as unidades organizacionais',
        identifier: 'Identificador',
        createUser: 'Criar Utilizador',
        saveFailed: 'Não foi possível guardar. Tente novamente.',
        titleCreate: 'Criar/Atualizar Utilizador',
        titleEdit: 'Editar Utilizador',
        selectOrganization: 'Selecionar Unidade Organizacional',
        firstName: 'Nome Próprio',
        lastName: 'Apelido',
        idNumber: 'Número de Identificação',
        employeeId: 'ID de Funcionário',
        phone: 'Telefone',
        email: 'Email',
        editUser: 'Editar Utilizador',
        deleteUserTitle: 'Eliminar Utilizador',
        sendWelcomeMessageConfirm: 'Enviar Mensagem',
        deleteUserText: 'Tem a certeza de que pretende eliminar o utilizador',
        deleteOrgConfirm: 'Eliminar Utilizador',
        deleteUserButton: 'Eliminar Utilizador',
        userIsCompanyAdmin: 'Administrador da Empresa',
        userIsOrgAdmin: 'Administrador da Unidade Organizacional',
        userIsOrgAdminTooltip: 'Para eliminar este utilizador, deve primeiro ser removido das funções de gestão em todas as unidades organizacionais',
        mfaRequired: 'Autenticação de Dois Fatores Obrigatória',
        sendWelcomeMessage: 'Enviar mensagem de início de sessão inicial aos utilizadores',
        save: 'Guardar/Atualizar Utilizador',
        userWillBeEditedIfPhoneExists: 'Se o número de telefone já estiver associado a um utilizador na empresa, esse utilizador e as unidades organizacionais a que pertence serão atualizados',
    },
    phoneEditModal: {
        title: 'Editar Número de Telefone',
        phoneLabel: 'Número de Telefone',
        phonePlaceholder: 'Introduzir número de telefone',
        cancel: 'Cancelar',
        save: 'Guardar',
        errors: {
            phone_already_exists: 'Este número de telefone já existe no sistema',
            phone_belongs_to_inactive_user: 'Este número de telefone pertence a um utilizador inativo',
            invalid_phone_format: 'Formato de número de telefone inválido',
            no_permission: 'Sem permissão para atualizar o número de telefone',
            network_error: 'Erro de rede; por favor, tente novamente',
            check_failed: 'Verificação de disponibilidade falhou; por favor, tente novamente',
        },
    },
    recurringAtEditModal: {
        title: 'Editar Data da Próxima Versão',
        dateLabel: 'Data da próxima versão',
        disclaimer: 'A alteração da data da próxima versão será aplicada a todos os utilizadores atribuídos a esta tarefa.',
        cancel: 'Cancelar',
        save: 'Guardar',
        errors: {
            saveFailed: 'Falha ao atualizar a data; por favor, tente novamente',
        },
    },
    allUsersTable: {
        columns: {
            fullName: 'Nome Completo',
            email: 'Email',
            phone: 'Telefone',
            roles: 'Funções',
            identifier: 'Identificador',
            idNumber: 'Número de Identificação',
            employeeId: 'ID de Funcionário',
            organization: 'Unidade Organizacional',
            id: 'ID',
            edit: 'Editar',
            delete: 'Eliminar',
            restore: 'Restaurar Utilizador',
            deleted: 'Eliminado',
            sendWelcomeMessage: 'Enviar Mensagem de Boas-Vindas',
            loginAs: 'Iniciar Sessão Como',
        },
            buttons: {
                deleteUsers: 'Eliminar Utilizadores',
            },
            filters: {
            allUsers: 'Todos os Utilizadores',
            activeOnly: 'Apenas Utilizadores Ativos',
            deletedOnly: 'Apenas Utilizadores Eliminados',
        }
    },
    removeCourseFromCompanyCol: {
        deleteCourseButton: 'Eliminar Curso',
        removeCourseTitle: 'Eliminar Curso',
        removeCourseText: 'Tem a certeza de que pretende eliminar o curso',
        removeCourseConfirm: 'Eliminar Curso',
    },
    CourseReminderNotificationButton: {
        alerts: {
            reminderSent: 'Os lembretes estão a caminho!',
            reminderNotSent: 'Erro ao enviar lembrete',
            sentMessages: 'Mensagens enviadas',
            notSentMessages: 'Mensagens não enviadas',
            notSentMessagesInfo: '* Podem existir duas razões pelas quais nem todas as mensagens foram enviadas: falta de informação de contacto ou número de telefone incorreto',
            sendToUsersWhoDidNotReceiveNotification: 'Enviar um lembrete aos utilizadores que ainda não receberam nenhum',
            sendToAllUsers: 'Enviar um lembrete a todos os utilizadores do curso que ainda não concluíram',
            error: 'Erro',
            company_has_no_sms_quota: 'A empresa não tem créditos de mensagens suficientes disponíveis, por favor contacte o serviço de apoio ao cliente para adquirir um pacote de mensagens',
            user_already_received_welcome_message: 'O utilizador já recebeu uma mensagem de boas-vindas',
            general_error: 'Ocorreu um erro ao enviar a notificação, por favor tente novamente mais tarde'
        }
    },
    FilesManagementPage: {
        title: 'Gestão de Ficheiros',
        subTitle: 'Ver, adicionar e editar',
        fileManagementTable: {
            columns: {
                fileName: 'Ligação de Transferência',
                presentationName: 'Nome de Apresentação',
                isReady: 'Pronto para Transferência',
                companyName: 'Empresa',
                organizationNames: 'Unidades Organizacionais',
                date: 'Data de Criação',
                createdByUser: 'Criado Por',
            },
            download: 'Transferir',
            inProgress: 'Criação em curso',
            ready: 'Pronto para transferência',
            allOrganizations: 'Todas as unidades organizacionais',
        }
    },
    SMSNotificationButton: {
        title: 'Enviar Lembrete',
        subTitle: 'Imediatamente'
    },
    sendSMSModal: {
        title: 'A quem estamos a lembrar?',
        sms: 'SMS',
        whatsapp: 'WhatsApp',
        email: 'Email',
        selectMessageDeliveryWay: 'As mensagens serão enviadas por:',
        sendToOptions: {
            all: 'Utilizadores que não concluíram uma tarefa específica',
            onlyNotNotified: 'Todos os que não concluíram o curso e não receberam um lembrete',
            allWithAnyOpenTasks: 'Utilizadores com tarefas em aberto',
            knowledgeCenter: 'Centro de Conhecimento',
            pleaseSelect: 'Por favor selecione o grupo para o qual pretende enviar',
            label: 'Para quem?'
        },
        taskOptions: {
            label: 'Qual tarefa?',
            pleaseSelect: 'Por favor selecione o curso para o qual pretende enviar um lembrete',
        },
        organizationOptions: {
            label: 'Qual unidade organizacional?',
            pleaseSelect: 'Por favor selecione a unidade organizacional para a qual pretende enviar um lembrete',
        },
        smsStatusInformation: {
            statusTitle: 'Ótimo!',
            statusUserToNotify: `Portanto, no total, estamos a lembrar `,
            bySMS: 'por SMS',
            byWhatsApp: 'por WhatsApp',
            byEmail: 'por Email',
            statusCompanyQuota: 'Para sua informação, após o envio, terá ',
            SMSForUse: 'mensagens restantes para utilizar',
            employees: 'colaboradores',
            theyWillReceiveItAsFollowing: 'que receberão as mensagens pelos seguintes métodos',
            existing: 'existentes',
            usersDontHaveEmails: 'utilizadores sem endereços de email'
        },
        error: {
            noUsersToSendOnlyNotNotified: 'Não há utilizadores para enviar; todos os utilizadores que não concluíram o curso já receberam um lembrete',
            notEnoughSMS: 'Não tem créditos de mensagens suficientes disponíveis, por favor contacte o serviço de apoio ao cliente para adquirir um pacote de mensagens',
            noUsersInCourse: 'Nenhum utilizador para enviar; todos os utilizadores neste curso já o concluíram',
            youAreLeftWithQuota: 'Ainda tem',
            youNeed: 'e precisa de um total de',
            toCompleteTheProcess: 'para concluir o processo',
        },
        send: 'Enviar'
    },
    SADeleteUsersModal: {
        title: 'Eliminar Utilizadores',
        firstName: 'Nome Próprio',
        lastName: 'Apelido',
        email: 'Email',
        phone: 'Telefone',
        employeeID: 'ID de Colaborador',
        idNumber: 'Número de Identificação',
        organizations: 'Organizações',
        identifier: 'Identificador',
        message: (key, {userCount}) => `Tem a certeza de que pretende eliminar os seguintes ${userCount} utilizadores?`,
        deleteUsers: 'Eliminar Utilizadores',
        fetchError: 'Erro ao carregar dados do utilizador',
        deleteError: 'Erro ao eliminar utilizadores',
        deleting: 'A eliminar...',

        // Confirmation view
        confirmMessage: (key, {userCount}) => `Tem a certeza de que pretende eliminar ${userCount} utilizadores?`,
        confirmHint: 'Os utilizadores que são administradores de unidades organizacionais não serão eliminados e serão apresentados no relatório de resultados.',

        // Results view
        resultsTitle: 'Resultados da Eliminação',
        successTitle: 'Eliminação Concluída com Sucesso',
        noDeletedTitle: 'Nenhum Utilizador Eliminado',

        deletedUsersTitle: 'Utilizadores Eliminados',
        skippedUsersTitle: 'Utilizadores Ignorados',

        // Result messages
        successMessageOnly: (key, {deleted}) => `${deleted} utilizador(es) eliminado(s) com sucesso.`,
        noDeletedMessage: (key) => `Nenhum utilizador foi eliminado.`,

        skippedExplanationTitle: 'Por que razão os utilizadores não foram eliminados?',
        skippedExplanation: 'Os seguintes utilizadores não foram eliminados porque são administradores de unidades organizacionais ou têm outras restrições. Para os eliminar, remova primeiro as suas permissões de administrador de todas as organizações relevantes.',

        skipReason: 'Motivo',
        reasons: {
            orgAdmin: 'Administrador Organizacional',
            adminOf: 'Administrador de',
            self: 'Não pode eliminar-se a si próprio',
            notFound: 'Utilizador não encontrado',
            // Deletion protection reasons from backend
            cannot_delete_self: 'Não pode eliminar-se a si próprio',
            cannot_delete_superadmin: 'Não é possível eliminar o SuperAdmin',
            cannot_delete_company_admin: 'Não é possível eliminar o Administrador da Empresa',
            cannot_delete_organizational_admin: 'Não é possível eliminar o Administrador Organizacional',
            different_company: 'O utilizador pertence a uma empresa diferente',
            not_an_organizational_admin: 'Não é um administrador organizacional',
            not_admin_of_all_user_organizations: 'Não é administrador de todas as organizações do utilizador',
            generic_error: 'O utilizador não pode ser eliminado'
        }
    },
    SARemoveUser: {
        permanentlyDeleteUser: 'Eliminação Permanente',
        deleteUserTitle: 'Eliminar Utilizador Permanentemente',
        deleteUserText: 'Tem a certeza de que pretende eliminar permanentemente o utilizador',
        deleteOrgConfirm: 'Eliminar Utilizador Permanentemente',
    },
    SADeleteUsersPermanentlyModal: {
        title: 'Eliminar Utilizadores Permanentemente',
        firstName: 'Nome Próprio',
        lastName: 'Apelido',
        email: 'Email',
        phone: 'Telefone',
        employeeID: 'ID de Colaborador',
        idNumber: 'Número de Identificação',
        organizations: 'Organizações',
        identifier: 'Identificador',
        warningTitle: 'Atenção! Ação Irreversível',
        warningMessage: (key, {userCount}) => `Está prestes a eliminar permanentemente ${userCount} utilizadores. Esta ação não pode ser desfeita e removerá permanentemente os utilizadores da base de dados.`,
        confirmationRequired: 'Para confirmar, escreva o seguinte texto:',
        confirmationText: 'eliminar permanentemente',
        confirmationPlaceholder: 'Escreva "eliminar permanentemente" para confirmar',
        deleteUsersPermanently: 'Eliminar Utilizadores Permanentemente',
        cancel: 'Cancelar',
        fetchError: 'Erro ao obter dados do utilizador',
        deleteError: 'Erro ao eliminar utilizadores permanentemente',
        deleting: 'A eliminar permanentemente...',
        confirmationMismatch: 'O texto introduzido não corresponde. Por favor escreva "eliminar permanentemente" exatamente.',
    },
    SARestoreUser: {
        restoreUsers: 'Restaurar Utilizadores',
        restoreUsersTitle: 'Restaurar Utilizadores',
        restoreUsersText: (key, {userCount}) => `Tem a certeza de que pretende restaurar ${userCount} utilizadores?`,
        restoreUsersConfirm: 'Sim, Restaurar Utilizadores',
    },
    automations: {
        title: 'Automatizações',
        subTitle: 'Gestão e Definições',
        addAutomation: 'Adicionar Automatização',
        editAutomation: 'Editar Automatização',
        deleteAutomation: 'Eliminar Automatização',
        automationName: 'Nome da Automatização',
        automationDescription: 'Descrição da Automatização',
        automationImage: 'Imagem da Automatização',
        automationCard: {
            editAutomation: 'Editar Automatização',
        },
        notifications: {
            title: 'Criar Automatização',
            subTitle: 'Para agendar lembretes',
        },
        createAutomationModal: {
            title: 'Criar Nova Automatização',
            weWillSendNotificationTo: 'Vamos lembrar todos os que não concluíram o curso ',
            allOrganizations: 'Todas as unidades organizacionais',
            allCourses: 'Todas as tarefas',
            automationKind: {
                signDoc: 'Lembretes de Tarefas',
                course: 'Lembretes de Cursos',
                signDocDescription: 'Lembretes para documentos a assinar, vídeos, áudio e outras tarefas',
                courseDescription: 'Lembretes para cursos regulares e materiais de aprendizagem'
            },
            organizationOptions: {
                label: 'Qual unidade organizacional?',
                pleaseSelect: 'Por favor, selecione a unidade organizacional para a qual pretende enviar um lembrete',
                error: 'Deve selecionar uma unidade organizacional para enviar o lembrete'
            },
            taskOptions: {
                label: 'Qual tarefa?',
                signDocLabel: 'Qual tarefa?',
                courseLabel: 'Qual curso?',
                pleaseSelect: 'Por favor, selecione a tarefa para a qual pretende enviar um lembrete',
                error: 'Deve selecionar um curso para enviar o lembrete'
            },
            selectHourLabel: 'A que horas?',
            selectHourError: 'Deve selecionar uma hora para enviar o lembrete',
            howManyDaysBefore: 'Quantos dias antes?',
            howManyDaysBeforeError: 'Deve selecionar quantos dias antes pretende enviar o lembrete',
            daysBeforeError: 'Deve selecionar um número válido de dias entre 1 e 50',
            nameLabel: 'Nome da Automatização',
            nameError: 'Deve introduzir um nome para a automatização',
            descriptionLabel: 'Descrição da Automatização',
            create: 'Criar Automatização',
            automationType: {
                label: 'Tipo de Automatização',
                oneTime: 'Lembrete Único',
                recurring: 'Lembretes Recorrentes'
            },
            recurring: {
                frequency: 'Frequência',
                every: 'Cada',
                startDate: 'Data de Início',
                endDate: 'Data de Fim (Opcional)',
                maxRuns: 'Número de Execuções',
                unlimited: 'Ilimitado',
                runHour: 'Hora de Execução',
                preview: 'Pré-visualização',
                startDateRequired: 'Deve introduzir uma data de início',
                startDatePast: 'A data de início não pode ser no passado',
                endDateInvalid: 'A data de fim deve ser posterior à data de início',
                maxRunsRequired: 'Deve introduzir um número máximo de execuções',
                runHourRequired: 'Deve selecionar uma hora de execução',
                daily: 'Diariamente',
                weekly: 'Semanalmente',
                monthly: 'Mensalmente',
                dailySingle: 'dia',
                dailyPlural: 'dias',
                weeklySingle: 'semana',
                weeklyPlural: 'semanas',
                monthlySingle: 'mês',
                monthlyPlural: 'meses',
            },
            modalRecurringPreview: (key, {frequencyText, runHour, runTimes}) => `Os lembretes serão enviados a cada ${frequencyText} às ${runHour}, num total de ${runTimes} execuções`
        }
    },
    automationsTable: {
        columns: {
            automationName: 'Nome da Automatização',
            automationType: 'Tipo de Automatização',
            description: 'Descrição da Automatização',
            organization: 'Unidades Organizacionais',
            task: 'Tarefas',
            when: 'Quando?',
            progress: 'Progresso',
            status: 'Estado',
            how: 'Como é enviado?',
            delete: 'Eliminar',
            edit: 'Editar',
            details: 'Detalhes',
        },

        status: {
            SCHEDULED: 'Agendado',
            COMPLETED: 'Concluído',
            PAUSED: 'Em Pausa',
            CANCELLED: 'Cancelado',
            sentAndNotSent: (key, {sent, notSent}) => `Enviado ${sent} e não enviado ${notSent}`,
        },
        sendType: {
            SMS: 'Mensagem de Texto',
            EMAIL: 'Email',
            WHATSAPP: 'WhatsApp',
        },
        atHour: 'às',
        daysBefore: 'dias antes da data de fim do curso',
        automationRuns: {
            title: 'Histórico de Execuções',
            columns: {
                runNumber: 'Execução #',
                scheduledTime: 'Hora Agendada',
                actualTime: 'Hora Real de Execução',
                status: 'Estado',
                usersProcessed: 'Utilizadores Verificados',
                messagesSent: 'Mensagens Enviadas',
                messagesFailed: 'Mensagens Falhadas',
                successRate: 'Taxa de Sucesso',
                details: 'Detalhes'
            },
            runStatuses: {
                SCHEDULED: 'Agendado',
                RUNNING: 'A Executar',
                COMPLETED: 'Concluído',
                FAILED: 'Falhado',
                SKIPPED: 'Ignorado'
            }
        },
        nextRun: 'Próxima Execução',
        lastRun: 'Última Execução',
        totalRuns: 'Total de Execuções',
        automationTypeBadge: {
            oneTime: 'Antes do fim',
            recurring: 'Recorrente'
        }
    },
    allOrganizations: 'Todas as unidades organizacionais',
    allSignDocs: 'Todas as tarefas',
    organizationIntersectionFilter: {
        label: 'Interseção de Organizações',
        tooltip: 'Filtrar utilizadores que pertencem a QUALQUER organização do grupo esquerdo E QUALQUER organização do grupo direito. Exemplo: se o grupo esquerdo tiver Org1,Org2 e o grupo direito tiver Org3,Org4, os resultados mostrarão utilizadores que estão em (Org1 OU Org2) E (Org3 OU Org4).'
    },
    confirmationModal: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
    },
    deleteAutomationModal: {
        title: 'Eliminar Automatização',
        message: 'Tem a certeza de que pretende eliminar a automatização?',
        deleteAutomation: 'Eliminar Automatização',
        automationName: 'Nome da Automatização',
    },
    newDocSign: {
        buttonTitle: 'Criar uma Nova Tarefa',
        modal: {
            title: 'Criar um Novo Documento',
            newVersionTitle: 'Criar Nova Versão',
            editSignDocTitle: 'Editar Documento',
            docNameLabel: {
                'REGULAR_COURSE': 'Nome do Documento',
                'READ_AND_SIGN_DOC_PDF': 'Nome do Documento',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'Nome do Vídeo',
                'WATCH_AND_SIGN_VIMEO_LINK': 'Nome do Vídeo',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Nome do Vídeo',
                'CANVA_PRESENTATION': 'Nome da Apresentação',
                'EXAM': 'Nome do Exame',
                'LEARNING_PATH': 'Nome do Percurso de Aprendizagem',
                'PODCAST': 'Nome do Podcast',
                'AUDIO_FILE': 'Nome do Ficheiro de Áudio',
                'FRONTAL_COURSE': 'Nome da Aula Presencial',
                'ONLINE_COURSE': 'Nome do Curso Online',
                'PRESENTATION': 'Nome da Apresentação',
                'ARTICLE': 'Nome do Artigo',
                'SURVEY': 'Nome do Inquérito',
                'LINK': 'Nome do Link',
                'UPLOAD_DOCUMENT': 'Nome da Tarefa',
            },
            docDescriptionLabel: {
                'REGULAR_COURSE': 'Descrição do Documento',
                'READ_AND_SIGN_DOC_PDF': 'Descrição do Documento',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'Descrição do Vídeo',
                'WATCH_AND_SIGN_VIMEO_LINK': 'Descrição do Vídeo',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Descrição do Vídeo',
                'CANVA_PRESENTATION': 'Descrição da Apresentação',
                'EXAM': 'Descrição do Exame',
                'LEARNING_PATH': 'Descrição do Percurso de Aprendizagem',
                'PODCAST': 'Descrição do Podcast',
                'AUDIO_FILE': 'Descrição do Ficheiro de Áudio',
                'FRONTAL_COURSE': 'Descrição da Aula Presencial',
                'ONLINE_COURSE': 'Descrição do Curso Online',
                'PRESENTATION': 'Descrição da Apresentação',
                'ARTICLE': 'Descrição do Artigo',
                'SURVEY': 'Descrição do Inquérito',
                'LINK': 'Descrição do Link',
                'UPLOAD_DOCUMENT': 'Descrição da Tarefa',
            },
            createButtonText: {
                'REGULAR_COURSE': 'Criar Curso',
                'READ_AND_SIGN_DOC_PDF': 'Criar Documento',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'Criar Tarefa de Visualização',
                'WATCH_AND_SIGN_VIMEO_LINK': 'Criar Tarefa de Visualização',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Criar Tarefa de Visualização',
                'AUDIO_FILE': 'Criar Tarefa de Audição',
                'CANVA_PRESENTATION': 'Criar Apresentação',
                'EXAM': 'Criar Exame',
                'LEARNING_PATH': 'Criar Percurso de Aprendizagem',
                'PODCAST': 'Criar Podcast',
                'FRONTAL_COURSE': 'Criar Aula Presencial',
                'ONLINE_COURSE': 'Criar Curso Online',
                'PRESENTATION': 'Criar Apresentação',
                'ARTICLE': 'Criar Artigo',
                'SURVEY': 'Criar Inquérito',
                'LINK': 'Criar Link',
                'UPLOAD_DOCUMENT': 'Criar Tarefa de Carregamento',
            },
            dropDocLabel: {
                'READ_AND_SIGN_DOC_PDF': 'Arraste o ficheiro PDF para aqui ou clique para selecionar o ficheiro',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Arraste o ficheiro de vídeo para aqui ou clique para selecionar o ficheiro',
                'AUDIO_FILE': 'Arraste o ficheiro de áudio para aqui ou clique para selecionar o ficheiro',
                'UPLOAD_DOCUMENT': 'Arraste o ficheiro para aqui ou clique para selecionar o ficheiro (PDF, DOC, DOCX, XLS, XLSX, TXT, JPG, PNG)',
            },
            examExtraSaveButton: 'Guardar e continuar a editar perguntas',
            weezBeeCourseExtraSaveButton: 'Guardar e continuar a editar o curso',
            learningPathExtraSaveButton: 'Guardar e continuar a editar o percurso de aprendizagem',
            surveyExtraSaveButton: 'Guardar e continuar a editar o inquérito',
            createDocument: 'Criar Documento',
            createExam: 'Criar Exame',
            createLearningPath: 'Criar Percurso de Aprendizagem',
            dropSignDocHere: 'Arraste o ficheiro do documento para aqui ou clique para selecionar o ficheiro',
            selectSignDocType: 'Tipo',
            linkUrl: 'Link',
            youtubeLinkNotAllowed: 'Não pode introduzir um link do Youtube',
            vimeoLinkNotAllowed: 'Não pode introduzir um link do Vimeo',
            canvaLinkNotAllowed: 'Não pode introduzir um link do Canva',
            invalidLink: "Link inválido",
            notifyUsersOfNewTask: 'Enviar uma mensagem aos utilizadores sobre uma nova tarefa',
            notifyUsersOfNewTaskTooltip: 'A mensagem será enviada apenas aos utilizadores que ainda não receberam uma notificação sobre esta tarefa',
            quotaWarning: {
                title: 'Créditos de Mensagem Insuficientes',
                message: (key, { quotaNeeded, quotaAvailable, totalUsers }) => `Precisa de ${quotaNeeded} créditos de mensagem para notificar ${totalUsers} utilizadores, mas apenas ${quotaAvailable} créditos estão disponíveis.`,
                contactSupport: 'Por favor, contacte o suporte para adquirir créditos de mensagem adicionais, ou desative o botão de notificação para guardar sem enviar notificações.',
                disableNotificationToSave: 'Desativar notificações para guardar o documento',
            },
            forceCompletion: 'Conclusão obrigatória',
            nonForceCompletion: 'Centro de Conhecimento',
            noDate: 'Sem data de fim',
            isMustDo: {
                label: 'Obrigatório para conformidade',
                tooltip: 'Os utilizadores devem concluir esta tarefa para passar na verificação de conformidade externa'
            },
            allowFastForward: {
                WATCH_AND_SIGN_VIDEO_FILE: 'Permitir avanço rápido no vídeo',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'Permitir avanço rápido no vídeo',
                WATCH_AND_SIGN_VIMEO_LINK: 'Permitir avanço rápido no vídeo',
                AUDIO_FILE: 'Permitir avanço rápido no ficheiro de áudio',
            },
            organizationAssignmentInfo: 'Poderá atribuir a tarefa às unidades organizacionais ao editar a tarefa',
            assignToAllOrganizations: 'Atribuir a todas as unidades organizacionais',
            removeFromAllOrganizations: 'Remover de todas as unidades organizacionais',
            assignmentTabs: {
                organizations: 'Atribuir a Unidades Organizacionais',
                individualUsers: 'Atribuir a Utilizadores Individuais'
            },
            assignmentSubTabs: {
                allUsers: 'Todos os Utilizadores',
                selected: 'Selecionados',
                noSelectedUsers: 'Nenhum utilizador selecionado'
            },
            recurring: {
                toggleLabel: 'Ativar Periódico',
                toggleDescription: 'Criar automaticamente novas versões em intervalos regulares',
                frequencyLabel: 'Periodicidade',
                frequencyNote: 'Os utilizadores serão reatribuídos a novas versões com base neste calendário',
                nextVersionDate: 'A próxima versão será criada em',
                minimumFrequencyError: 'A periodicidade mínima é 1 mês',
                nextVersionDateLabel: 'Data da próxima versão',
                transitionDisclaimer: 'Esta tarefa está a ser alterada de uma tarefa regular para uma tarefa periódica. Deve selecionar uma data para a próxima versão. Esta data será aplicada a todos os utilizadores atribuídos. Após esta data, novas versões serão criadas automaticamente com base na frequência selecionada. Pode editar esta data a qualquer momento na página de gestão de versões.',
            },
            groupType: {
                label: 'Frequência',
                SEQUENTIAL: 'Periódico',
                PARALLEL: 'Sem Frequência'
            },
            status: {
                label: 'Estado',
                ACTIVE: 'Ativo',
                ARCHIVED: 'Arquivado'
            }
        },
    },
    signDocModal: {
        importUsers: {
            modalTitle: 'Importar Utilizadores de Ficheiro',
            importFromFile: 'Importar de ficheiro',
            matchedUsers: 'Utilizadores Correspondentes',
            unmatchedRows: 'Linhas Sem Correspondência',
            addUsers: (key, {count}) => `Adicionar ${count} Utilizadores`,
            noMatchesFound: 'Nenhum utilizador correspondente encontrado',
            unmatchedRowsHint: "Estas linhas não corresponderam a nenhum utilizador no sistema. Verifique se os números de telefone estão corretos.",
            processingFile: 'A processar ficheiro...',
            fileError: 'Erro ao ler o ficheiro'
        }
    },
    signDocProgress: {
        notStarted: {
            READ_AND_SIGN_DOC_PDF: 'Não lido',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Não visto',
            WATCH_AND_SIGN_VIMEO_LINK: 'Não visto',
            WATCH_AND_SIGN_VIDEO_FILE: 'Não visto',
            AUDIO_FILE: 'Não ouvido',
            REGULAR_COURSE: 'Não iniciado',
            CANVA_PRESENTATION: 'Não visto',
            EXAM: 'Não iniciado',
            LEARNING_PATH: 'Não iniciado',
            LINK: 'Não visitado',
            SURVEY: 'Não iniciado',
            WEEZBEE_COURSE: 'Não iniciado',
            UPLOAD_DOCUMENT: 'Não carregado',
            FRONTAL_COURSE: 'Não compareceu',
            ONLINE_COURSE: 'Não iniciado',
        },
        inProgress: {
            READ_AND_SIGN_DOC_PDF: 'Lido',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Iniciado',
            WATCH_AND_SIGN_VIMEO_LINK: 'Iniciado',
            WATCH_AND_SIGN_VIDEO_FILE: 'Iniciado',
            AUDIO_FILE: 'Ouvido',
            REGULAR_COURSE: 'Iniciado',
            CANVA_PRESENTATION: 'Visto',
            EXAM: 'Iniciado',
            LEARNING_PATH: 'Iniciado',
            LINK: 'Visitado',
            SURVEY: 'Iniciado',
            WEEZBEE_COURSE: 'Iniciado',
            UPLOAD_DOCUMENT: 'Carregado',
            FRONTAL_COURSE: 'Inscrito',
            ONLINE_COURSE: 'Inscrito',
        },
        finished: {
            READ_AND_SIGN_DOC_PDF: 'Assinado!',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Concluído!',
            WATCH_AND_SIGN_VIMEO_LINK: 'Concluído!',
            WATCH_AND_SIGN_VIDEO_FILE: 'Concluído!',
            AUDIO_FILE: 'Concluído!',
            REGULAR_COURSE: 'Concluído!',
            CANVA_PRESENTATION: 'Assinado!',
            EXAM: 'Concluído!',
            LEARNING_PATH: 'Concluído!',
            LINK: 'Lido!',
            SURVEY: 'Concluído!',
            WEEZBEE_COURSE: 'Concluído!',
            UPLOAD_DOCUMENT: 'Aprovado',
            FRONTAL_COURSE: 'Concluído!',
            ONLINE_COURSE: 'Concluído!',
        },
        completedOn: 'Data de Assinatura: ',
        completedOnCourse: 'Data de Conclusão: ',
        by: 'por ',
        manual: 'Manual',
        finishBy: 'A concluir até: ',
        score: 'Pontuação',
    },
    signDocProgressMgmnt: {
        notStarted: 'Não Aberto',
        inProgress: 'Aberto',
        finished: 'Assinado',
        opened: 'Aberto'
    },
    signDocPage: {
        title: {
            read: {
                sign: 'Aprovação de Leitura de Documento',
                noSign: 'Leitura de Documento',
                knowledgeOnly: 'Leitura de Documento'
            },
            watch: {
                sign: 'Aprovação de Visualização de Vídeo',
                noSign: 'Visualização de Vídeo',
                knowledgeOnly: 'Visualização de Vídeo'
            },
            listen: {
                sign: 'Aprovação de Audição de Áudio',
                noSign: 'Audição de Áudio',
                knowledgeOnly: 'Audição de Áudio'
            },
            link: {
                sign: 'Aprovação de Visita a Ligação'
            },
            upload: {
                sign: 'Carregamento de Documento',
                noSign: 'Ver Documento Carregado',
                knowledgeOnly: 'Carregamento de Documento'
            },
            canva: {
                sign: 'Aprovação de Visualização de Apresentação',
                noSign: 'Visualização de Apresentação',
                knowledgeOnly: 'Visualização de Apresentação'
            }
        },
        subTitle: {
            read: {
                sign: 'Aprove e assine que leu o documento',
                noSign: 'Releitura após assinatura',
            },
            watch: {
                sign: 'Aprove e assine que viu o vídeo',
                noSign: 'Nova visualização após assinatura',
            },
            listen: {
                sign: 'Aprove e assine que ouviu o áudio',
                noSign: 'Nova audição após assinatura',
            },
            link: {
                sign: 'Aprove e assine que visitou a ligação'
            },
            upload: {
                sign: 'Por favor, carregue o documento necessário',
                noSign: 'Documento carregado com sucesso'
            },
            canva: {
                sign: 'Percorra toda a apresentação e assine para confirmar',
                noSign: 'Nova visualização após assinatura'
            }
        },
        signatureTitle: {
            read: 'Assine para confirmar que leu o documento',
            watch: 'Assine para confirmar que viu o vídeo',
            listen: 'Assine para confirmar que ouviu o áudio',
            link: 'Assine para confirmar que visitou a ligação',
            canva: 'Assine para confirmar que concluiu toda a apresentação',
        },
        signatureSubtitle: {
            read: 'Para confirmar a leitura do documento, assine aqui',
            watch: 'Para confirmar a visualização do vídeo, assine aqui',
            listen: 'Para confirmar a audição do áudio, assine aqui',
            link: 'Para confirmar a visita à ligação, assine aqui',
            canva: 'Para confirmar a conclusão da apresentação, assine aqui',
        },
        signatureSubtitleNotCompleted: {
            read: 'Após a leitura, aparecerá um campo de assinatura e botão de confirmação',
            watch: 'Após a visualização, aparecerá um campo de assinatura e botão de confirmação',
            listen: 'Após a audição, aparecerá um campo de assinatura e botão de confirmação',
            canva: 'Após concluir a apresentação, aparecerá um campo de assinatura e botão de confirmação',
        },
        iApproveReadingTheDoc: {
            read: 'Li o documento!',
            watch: 'Vi o vídeo!',
            listen: 'Ouvi o áudio!',
            link: 'Visitei a ligação!',
            canva: 'Concluí a apresentação!',
        },
        clear: 'Limpar Assinatura',
        uploadDocument: {
            title: 'Carregar Documento',
            subtitle: 'Por favor, carregue o documento necessário',
            completed: 'Documento Aprovado com Sucesso',
            completedMessage: 'Obrigado! O seu documento foi aprovado com sucesso pelo administrador.',
            uploaded: 'Documento Carregado com Sucesso',
            waitingApproval: 'O documento está a aguardar aprovação do administrador',
            uploadedFile: 'Documento Carregado',
            fileSize: 'Tamanho do Ficheiro',
            stepUploaded: 'Carregado',
            replaceFile: 'Arraste um novo ficheiro ou clique para substituir',
            uploadedFiles: 'Ficheiros Carregados',
            saveButton: 'Guardar e Voltar ao Início',
            rejectionTitle: 'O Seu Documento Foi Rejeitado',
            rejectionReasonLabel: 'Motivo de Rejeição',
            rejectedBy: 'Rejeitado por',
            rejectionNoReason: 'O administrador rejeitou o documento sem fornecer um motivo.',
            rejectionAction: 'Por favor, carregue um novo documento de acordo com as diretrizes.',
            successModal: {
                title: 'Documento Guardado com Sucesso!',
                message: 'O seu documento foi carregado com sucesso e está a aguardar aprovação do administrador.',
                autoRedirect: 'A redirecionar para a página inicial...'
            },
            enableApprovals: {
                toggleLabel: 'Exigir aprovação para carregamentos',
                enabledNote: 'Quando ativado, os administradores devem aprovar os ficheiros carregados pelos utilizadores antes de a tarefa ser marcada como concluída.',
                disabledNote: 'Quando desativado, os ficheiros carregados pelos utilizadores serão aprovados automaticamente e a tarefa será marcada como concluída de imediato.'
            }
        },
        courseAttendanceApprovals: {
            sectionTitle: 'Aprovadores de Presença',
            description: 'Selecione utilizadores específicos que podem marcar presença neste curso. Se nenhum for selecionado, apenas os administradores da empresa podem marcar presença.',
            userLabel: 'Selecionar utilizadores como aprovadores de presença',
        }
    },
    filePreview: {
        noPreviewAvailable: 'Sem pré-visualização disponível',
        notAvailable: 'Pré-visualização não disponível para este tipo de ficheiro',
        downloadToView: 'Transferir ficheiro para visualizar'
    },
    signDocCard: {
        rejected: 'Rejeitado',
        rejectedMessage: 'O seu documento foi rejeitado',
        uploadAgain: 'Carregar Novamente',
        noDateSet: 'Sem data definida',
        youAreDone: {
            READ_AND_SIGN_DOC_PDF: 'Assinou o documento',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Assistiu ao vídeo',
            WATCH_AND_SIGN_VIMEO_LINK: 'Assistiu ao vídeo',
            WATCH_AND_SIGN_VIDEO_FILE: 'Assistiu ao vídeo',
            AUDIO_FILE: 'Ouviu o ficheiro de áudio',
            REGULAR_COURSE: 'Concluiu o curso',
            CANVA_PRESENTATION: 'Assistiu à apresentação',
            EXAM: 'Concluiu o exame',
            WEEZBEE_COURSE: 'Concluiu o curso',
            LEARNING_PATH: 'Concluiu a formação',
            LINK: 'Visitou o link',
            SURVEY: 'Concluiu o inquérito',
            UPLOAD_DOCUMENT: 'Carregou o documento',
            FRONTAL_COURSE: 'Participou na palestra',
            ONLINE_COURSE: 'Concluiu o curso online',
        },
        finishBy: {
            READ_AND_SIGN_DOC_PDF: (key, {finishByDate}) => `Deve assinar até ${finishByDate}`,
            WATCH_AND_SIGN_YOUTUBE_LINK: (key, {finishByDate}) => `Deve assistir até ${finishByDate}`,
            WATCH_AND_SIGN_VIMEO_LINK: (key, {finishByDate}) => `Deve assistir até ${finishByDate}`,
            WATCH_AND_SIGN_VIDEO_FILE: (key, {finishByDate}) => `Deve assistir até ${finishByDate}`,
            AUDIO_FILE: (key, {finishByDate}) => `Deve ouvir até ${finishByDate}`,
            REGULAR_COURSE: (key, {finishByDate}) => `Deve concluir até ${finishByDate}`,
            CANVA_PRESENTATION: (key, {finishByDate}) => `Deve assistir até ${finishByDate}`,
            EXAM: (key, {finishByDate}) => `Deve concluir até ${finishByDate}`,
            WEEZBEE_COURSE: (key, {finishByDate}) => `Deve concluir até ${finishByDate}`,
            LEARNING_PATH: (key, {finishByDate}) => `Deve concluir até ${finishByDate}`,
            LINK: (key, {finishByDate}) => `Deve visitar até ${finishByDate}`,
            SURVEY: (key, {finishByDate}) => `Deve concluir até ${finishByDate}`,
            UPLOAD_DOCUMENT: (key, {finishByDate}) => `Deve carregar até ${finishByDate}`,
            FRONTAL_COURSE: (key, {finishByDate}) => `Palestra em: ${finishByDate}`,
            ONLINE_COURSE: (key, {finishByDate}) => `Sessão do curso: ${finishByDate}`,
        },
        youAreDoneWatchAgain: {
            READ_AND_SIGN_DOC_PDF: 'Ler novamente',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Ver novamente',
            WATCH_AND_SIGN_VIMEO_LINK: 'Ver novamente',
            WATCH_AND_SIGN_VIDEO_FILE: 'Ver novamente',
            AUDIO_FILE: 'Ouvir novamente',
            REGULAR_COURSE: 'Ver novamente',
            CANVA_PRESENTATION: 'Ver novamente',
            EXAM: 'Rever exame',
            LEARNING_PATH: 'Rever formação',
            LINK: 'Visitar novamente',
            SURVEY: 'Rever inquérito',
            WEEZBEE_COURSE: 'Rever curso',
            UPLOAD_DOCUMENT: 'Ver tarefa novamente',
            FRONTAL_COURSE: 'Ver detalhes novamente',
            ONLINE_COURSE: 'Ver novamente',
        },
        goToCourse: {
            READ_AND_SIGN_DOC_PDF: 'Ir para a leitura',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Ir para ver',
            WATCH_AND_SIGN_VIMEO_LINK: 'Ir para ver',
            WATCH_AND_SIGN_VIDEO_FILE: 'Ir para ver',
            AUDIO_FILE: 'Ir para ouvir',
            REGULAR_COURSE: 'Ir para o curso',
            CANVA_PRESENTATION: 'Ir para ver',
            EXAM: 'Ir para o exame',
            LEARNING_PATH: 'Ir para o percurso',
            LINK: 'Ir para o link',
            SURVEY: 'Ir para o inquérito',
            WEEZBEE_COURSE: 'Ir para o curso',
            UPLOAD_DOCUMENT: 'Ir para a página de carregamento',
            FRONTAL_COURSE: 'A conclusão será aprovada pelo administrador',
            ONLINE_COURSE: 'Ir para o curso',
        },
        disabledButtonTooltips: {
            locked: 'A tarefa está bloqueada e não está disponível agora',
            surveyNotRedoable: 'O inquérito é anónimo e já foi concluído, pelo que não pode ser feito novamente',
            genericNotRedoable: 'A tarefa já foi concluída e não pode ser feita novamente',
            frontalCourseDisabled: 'A presença em cursos presenciais é marcada apenas pelo administrador'
        },
        examScore: (key, { score }) => `Pontuação: ${score}`,
        completedByAdmin: 'Concluído pelo administrador',
    },
    Errors_409: {
        storage_quota_error: (key, {bytesCompanyStorageQuota, bytesCompanyUsedStorage, bytesNewUsedStorage}) => {
            const leftQuotaMB = ((bytesCompanyStorageQuota - bytesCompanyUsedStorage) / (1024 * 1024)).toFixed(2) + ' MB';
            const bytesNewUsedStorageMB = (bytesNewUsedStorage / (1024 * 1024)).toFixed(2) + ' MB';
            const bytesCompanyStorageQuotaMB = (bytesCompanyStorageQuota / (1024 * 1024)).toFixed(2) + ' MB';
            return `Espaço de armazenamento insuficiente. Tente eliminar ficheiros ou contacte o administrador do sistema. Tem ${leftQuotaMB} disponíveis de ${bytesCompanyStorageQuotaMB} no total, e o ficheiro que está a tentar carregar tem ${bytesNewUsedStorageMB}`;
        },
        missing_company_organization: 'Deve selecionar uma unidade organizacional para o utilizador',
        user_already_received_welcome_message: 'O utilizador já recebeu a mensagem de boas-vindas',
        company_has_no_sms_quota: 'A empresa não tem créditos SMS suficientes disponíveis, por favor contacte o suporte ao cliente para adquirir um pacote de mensagens',
        original_password_dont_match: 'A palavra-passe fornecida está incorreta',
        password_too_weak: 'A palavra-passe não é suficientemente forte',
        organization_still_has_users: 'Ainda existem utilizadores na unidade organizacional que precisam de ser eliminados ou atribuídos a outra unidade organizacional',
        total_points_exceed_100: 'A soma de todas as pontuações das perguntas não pode exceder 100',
        user_not_found: 'Utilizador não encontrado, por favor verifique se o email ou número de telefone fornecido está correto. Se o utilizador ainda não for encontrado, contacte o administrador do sistema',
    },
    signDocTypes: {
        READ_AND_SIGN_DOC_PDF: 'Documento PDF para Assinar',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'Link do Youtube para Ver',
        WATCH_AND_SIGN_VIMEO_LINK: 'Link do VIMEO para Ver',
        WATCH_AND_SIGN_VIDEO_FILE: 'Ficheiro de Vídeo para Ver',
        REGULAR_COURSE: 'Curso',
        CANVA_PRESENTATION: 'Apresentação Canva para Ver',
        EXAM: 'Exame',
        WEEZBEE_COURSE: 'Curso WeezBee',
        LEARNING_PATH: 'Percurso de Aprendizagem',
        AUDIO_FILE: 'Ficheiro de Áudio',
        LINK: 'Link para Visitar',
        SURVEY: 'Inquérito',
        UPLOAD_DOCUMENT: 'Documento para Carregar',
        FRONTAL_COURSE: 'Formação Presencial',
        ONLINE_COURSE: 'Formação Online',
    },
    signDocTypesNotForCompletion: {
        READ_AND_SIGN_DOC_PDF: 'Documento PDF',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'Link do Youtube',
        WATCH_AND_SIGN_VIMEO_LINK: 'Link do VIMEO',
        WATCH_AND_SIGN_VIDEO_FILE: 'Ficheiro de Vídeo',
        REGULAR_COURSE: 'Curso',
        CANVA_PRESENTATION: 'Apresentação Canva',
        EXAM: 'Exame',
        LINK: 'Link',
        WEEZBEE_COURSE: 'Curso WeezBee',
        LEARNING_PATH: 'Percurso de Aprendizagem',
        AUDIO_FILE: 'Ficheiro de Áudio',
        SURVEY: 'Inquérito',
        UPLOAD_DOCUMENT: 'Carregar Documento',
        FRONTAL_COURSE: 'Formação Presencial',
        ONLINE_COURSE: 'Formação Online',
    },
    managementCourseList: {
        signDocButtonTitle: 'Criar Tarefa de Visualização'
    },
    isCompanyAdmin: {
        makeAdmin: {
            title: 'Definir como Administrador da Empresa',
            message: 'Tem a certeza de que pretende definir o utilizador como administrador da empresa?',
            confirm: 'Definir como Administrador da Empresa',
            button: 'Definir como Administrador da Empresa',
        },
        removeAdmin: {
            title: 'Remover Administrador da Empresa',
            message: 'Tem a certeza de que pretende remover o utilizador do papel de administrador da empresa?',
            confirm: 'Remover Administrador da Empresa',
            button: 'Remover Administrador da Empresa',
        },
        userName: 'Nome de utilizador',
    },
    general: {
        saveChanges: 'Guardar Alterações',
        close: 'Fechar',
        cancel: 'Cancelar',
        save: 'Guardar',
        deleteConfirm: 'Confirmar eliminação?',
        delete: 'Eliminar',
        areYouSure: 'Tem a certeza?',
        copyOf: 'Cópia de',
        duplicating: 'A duplicar...',
        next: 'Seguinte',
        back: 'Voltar',
    },
    knowledgeCenter: {
        title: 'Centro de Conhecimento',
        subTitle: 'Toda a informação num só lugar',
    },
    operation: {
        title: 'Operação',
        subTitle: 'Toda a informação operacional num só lugar',
    },
    adminUsersTable: {
        columns: {
            fullName: 'Nome Completo',
            firstName: 'Primeiro Nome',
            lastName: 'Apelido',
            email: 'Email',
            phone: 'Telefone',
            roles: 'Funções',
            identifier: 'Identificador',
            managerOfOrganizations: 'Gestor em Unidades Organizacionais',
            id: 'ID',
            edit: 'Editar',
            isCompanyAdmin: 'Administrador da Empresa',
            isCompanyAdminYes: 'Sim',
            isCompanyAdminNo: 'Não',
        },
        addAdminUser: 'Adicionar Administrador',
    },
    editAdminUserModal: {
        title: 'Atribuir Administrador',
        titleEdit: 'Editar Administrador',
        sendWelcomeMessage: 'Enviar mensagem de boas-vindas ao administrador',
        save: 'Guardar Alterações',
        selectOrganizationalUnits: 'Pesquisar Unidades Organizacionais',
        searchUser: 'Pesquisar Utilizador',
        isCompanyAdmin: 'Administrador da Empresa',
        companyAdminWillBeAdminOfAllOrgs: 'Um administrador de empresa será administrador de todas as unidades organizacionais',
        selectAllOrgs: 'Selecionar todas as unidades organizacionais',
    },
    autoComplete: {
        search: 'Pesquisar',
        selectAll: 'Selecionar Tudo',
        noOptions: 'Nenhum resultado encontrado',
    },
    UserIconMenu: {
        settings: 'Definições',
    },
    deletedUserTable: {
        emailNotAssigned: 'Nenhum email fornecido',
        columns: {
            fullName: 'Nome Completo',
            firstName: 'Primeiro Nome',
            lastName: 'Apelido',
            phoneNumber: 'Telemóvel',
            email: 'Email',
            firstLoginDate: 'Data de Adesão',
            deletedDate: 'Data de Eliminação',
            userDetails: 'Detalhes do Utilizador'
        },
    },
    deletedUsersPage: {
        buttons: {
            downloadCsv: 'Exportar para CSV',
            downloadCsvForOrganizations: 'Exportar utilizadores eliminados para as unidades organizacionais selecionadas',
            restoreUsers: 'Restaurar utilizadores',
        }
    },
    restoreUsersModal: {
        title: 'Restaurar utilizadores eliminados',
        resultsTitle: 'Resultados da restauração',
        confirmMessage: (key, {userCount}) => `Está prestes a restaurar ${userCount} utilizador(es). Continuar?`,
        confirmHint: 'Os utilizadores restaurados serão reatribuídos às suas unidades organizacionais anteriores.',
        restoreUsers: 'Restaurar utilizadores',
        restoring: 'A restaurar...',
        restoreError: 'Ocorreu um erro ao restaurar os utilizadores. Por favor, tente novamente.',
        successMessage: (key, {restored}) => `${restored} utilizador(es) restaurado(s) com sucesso`,
        noRestoredMessage: 'Nenhum utilizador foi restaurado',
        restoredUsersTitle: 'Utilizadores restaurados',
        skippedUsersTitle: 'Utilizadores ignorados',
        skippedExplanationTitle: 'Por que razão alguns utilizadores foram ignorados?',
        skippedExplanation: 'Alguns utilizadores não puderam ser restaurados devido a erros internos. Tente novamente ou contacte o suporte se o problema persistir.',
        firstName: 'Primeiro nome',
        lastName: 'Apelido',
        email: 'Email',
        employeeID: 'ID do Colaborador',
        idNumber: 'Número de identificação',
        organizations: 'Unidades organizacionais',
        skipReason: 'Motivo',
        reasons: {
            restore_failed: 'Ocorreu um erro durante a restauração',
        },
    },
    deletedUserModal: {
        title: 'Os documentos e cursos que estavam associados a',
        columns: {
            docName: 'Nome da Tarefa',
            status: 'Estado',
            completedOnDate: 'Data de Conclusão',
            expiryDate: 'Data de Expiração',
            type: 'Tipo de Tarefa',
            category: 'Categoria',
            score: 'Pontuação',
            actions: 'Ações',
        },
        status: {
            finished: 'Concluído',
            inProgress: 'Em Progresso',
            waitingForApproval: 'A Aguardar Aprovação',
            notStarted: 'Não Iniciado',
            signed: "Assinado"
        },
        signDocData: {
            unCompletedCourse: 'A tarefa não foi concluída',
            completedByAdmin: 'Concluído pelo administrador da empresa',
            doNotForceCompletion: 'Enriquecimento'
        }
    },
    userDetailsModal: {
        learningPath: {
            expandTasks: 'Mostrar tarefas do percurso de aprendizagem',
            collapseTasks: 'Ocultar tarefas do percurso de aprendizagem'
        },
        progressSummary: {
            title: 'Resumo do Progresso',
            completed: 'Concluído',
            inProgress: 'Em Progresso',
            notStarted: 'Não Iniciado',
            tasksCompleted: 'tarefas concluídas'
        },
        statusFilter: {
            archived: 'Arquivadas'
        },
        archivedTag: 'Arquivado',
        actions: {
            updateExpiryDate: 'Atualizar Data de Expiração',
            declineApproval: 'Recusar Aprovação',
            markAttended: 'Marcar como Presente',
            markNoShow: 'Marcar como Ausente'
        }
    },
    FirstLoginModal: {
        title: 'Que entusiasmo começar a aprender juntos!',
        content: 'Tem de concluir as tarefas abertas no ecrã inicial até à data prevista.\n' +
            'Boa sorte!',
        takeMeHome: 'Ótimo, leva-me ao ecrã inicial'
    },
    organizationalUnitTable: {
        columns: {
            organizationalUnitName: 'Nome da Unidade Organizacional',
            createAt: 'Criado Em',
            details: 'Detalhes',
            delete: 'Eliminar',
            userCount: 'Número de Utilizadores',
            updateOrgName: "Atualizar Nome da Unidade Organizacional",
        },
        removeOrgCell: {
            columns: {
                firstName: 'Primeiro Nome',
                lastName: 'Apelido',
                organizationChange: 'Alterar Unidade Organizacional',
                deleteUser: 'Eliminar Utilizador'
            },
            modalNotAllowedDeleteTitle: 'Para eliminar uma unidade organizacional, deve reatribuir todos os utilizadores a pelo menos outra unidade ou eliminá-los.',
            modalAllowDeleteTitle: 'Não existem utilizadores na unidade organizacional, pode eliminá-la.',
            button: 'Eliminar Unidade Organizacional',
            tooltipMessage: 'Para eliminar uma unidade organizacional, deve remover ou reatribuir todos os utilizadores que nela se encontram.',
            alertErrorDeleteOrgTitle: 'Erro ao Eliminar Unidade Organizacional',
            failedDeleteOrgError: 'Não foi possível eliminar a unidade organizacional, lamentamos! Por favor, atualize a página e tente novamente.'
        },
        editOrgNameCell: {
            button: 'Atualizar nome da unidade organizacional',
        }
    },
    questionnaire: {
        buttons: {
            continueToQuestionPool: 'Guardar e continuar a editar perguntas',
        },
        modal: {
            title: 'Criar um novo questionário',
            passGrade: 'Nota de aprovação',
            timeToFinish: 'Tempo do exame',
            canUserReview: 'Permitir ao examinando rever as respostas',
            allowedTries: 'Tentativas permitidas'
        }
    },
    questionnaireQuestions: {
        questionText: 'Texto da Pergunta',
        questionType: 'Tipo de Pergunta',
        options: 'Opções',
        markAsCorrect: 'Marcar como resposta correta',
        addOption: 'Adicionar opção',
        validation: {
            modalTitle: 'Por favor corrija os seguintes erros antes de guardar o exame',
            questionIndexError: 'Erro na pergunta número',
            closeAndFix: 'Fechar e corrigir',
            navigateToQuestion: 'Ir para a pergunta',
            minimumOptions: 'Existem menos de 2 respostas corretas possíveis para a pergunta',
            noCorrectAnswer: 'Não foi selecionada nenhuma resposta correta para a pergunta',
            duplicateOptions: 'Existem 2 opções com respostas idênticas',
        },
        aiLoadingTexts: {
            loading: 'A gerar perguntas para si...',
            pleaseWait: 'Por favor aguarde...',
            testWillBeReadySoon: 'O seu exame estará pronto em breve...',
            aBitMorePatience: 'Só mais um pouco de paciência...',
            itMightTakeABitLongerButItsWorthIt: `Isto pode demorar mais alguns segundos, mas valerá a pena...`,
        },
        tooltip: {
            pleaseFillSubject: 'Por favor preencha o tema do exame',
        },
        placeHolders: {
            questionText: 'Insira a sua pergunta aqui...',
            subject: '*Tema do exame',
            description: 'Descrição breve',
            question: 'Pergunta',
            FREE_TEXT: 'Texto de resposta curta',
            option: 'Opção',
            NO_ANSWER: 'Esta secção é apenas para fins informativos e não tem resposta',
            questionCount: 'Número de perguntas',
        },
        question: 'Pergunta',
        FREE_TEXT: 'Texto de resposta curta',
        option: 'Opção',
        NO_ANSWER: 'Esta secção é apenas para fins informativos e não tem resposta',
        messages: {
            deleteLastQuestion: 'Não é possível eliminar a última pergunta',
        },
        headers: {
            poolQuestion: 'Editar Exame',
            poolQuestionSubTitle: 'Número de perguntas criadas para o exame',
        },
        buttons: {
            addOption: 'Adicionar opção +',
            saveQuestions: 'Guardar perguntas',
            saveQuestionsSubTitle: 'Guardar todas as perguntas do exame',
            genAIQuestions: 'Gerar Perguntas com IA',
        },
        aiModal: {
            questionQuantityLabel: 'Número de perguntas a gerar',
        },
        questionOptions: {
            MULTIPLE_CHOICE: 'Escolha única',
            CHECKBOX: 'Escolha múltipla',
            FREE_TEXT: 'Pergunta aberta',
            NO_ANSWER: 'Parágrafo curto',
            RATING_SCALE: 'Escala de Avaliação',
        },
        survey: {
            anonymousToggle: 'Inquérito Anónimo',
            anonymousDescription: 'Quando ativado, os detalhes do utilizador que preencheu o inquérito não serão guardados',
            ratingScale: {
                title: 'Definições da Escala de Avaliação',
                minValue: 'Valor Mínimo',
                maxValue: 'Valor Máximo',
                minLabel: 'Etiqueta Mínima',
                maxLabel: 'Etiqueta Máxima',
                defaultMinLabel: 'Não Satisfeito',
                defaultMaxLabel: 'Muito Satisfeito',
                previewTitle: 'Pré-visualização',
            }
        },
        addImage: 'Adicionar Imagem à Pergunta',
        hasImage: 'A pergunta contém uma imagem',
        dropImageOrClick: 'Arraste a imagem aqui ou clique para selecionar',
        uploading: 'A carregar imagem...',
        supportedFormats: 'Formatos Suportados',
        deleteImageTitle: 'Eliminar Imagem',
        confirmDeleteImage: 'Tem a certeza de que pretende eliminar a imagem?',
        errors: {
            invalidImageType: 'Tipo de ficheiro não suportado. Por favor carregue uma imagem em formato JPG, PNG, GIF ou WEBP',
            imageTooLarge: 'O tamanho do ficheiro excede 10MB',
            uploadFailed: 'O carregamento da imagem falhou',
            deleteFailed: 'A eliminação da imagem falhou',
        }
    },
    weezbeeCourse: {
        addContent: 'Adicionar Conteúdo',
        contentType: 'Tipo de Conteúdo',
        contentTypes: {
            text: 'Texto',
            video: 'Vídeo',
            image: 'Imagem',
            quiz: 'Quiz',
            pdf: 'PDF'
        },
        orientationOverlay: {
            title: 'Por Favor Rode o Seu Dispositivo',
            message: 'Para uma melhor experiência, por favor rode o seu dispositivo para o modo horizontal.'
        },
        fullscreenPrompt: {
            title: 'Mostrar curso em ecrã inteiro',
            buttonText: 'Entrar em Ecrã Inteiro',
            errors: {
                permissionDenied: 'Permissão negada. Por favor tente novamente tocando no botão de ecrã inteiro.',
                generic: 'Erro de ecrã inteiro: {message}'
            }
        },
        chapterPanel: {
            title: 'Capítulos',
            generating: 'A gerar...',
            aiCreating: 'A IA está a criar este capítulo...',
            deleteChapter: 'Eliminar Capítulo',
            duplicateChapter: 'Duplicar Capítulo',
            copySuffix: '(cópia)',
        },
        question: {
            defaultText: 'Introduza aqui a sua pergunta',
            tryAgain: 'Ups, resposta errada. Tente novamente!',
            submitAnswer: 'Submeter Resposta',
            correct: 'Correto!',
            incorrect: 'Incorreto',
        },
        navigation: {
            back: 'Anterior',
            next: 'Seguinte'
        },
        aiGeneration: {
            generateCourse: 'Gerar Curso com IA',
            courseLengthMinutes: 'Duração do Curso (minutos)',
            courseLengthMinutesHelp: 'Introduza um valor entre 5 e 30 minutos',
            descriptionPlaceholder: 'Descrição breve do curso...',
            tooltip: {
                pleaseEnterDescription: 'Por favor introduza uma descrição do curso (5-150 caracteres)',
                pleaseEnterValidCourseLength: 'Por favor introduza uma duração válida para o curso (5-30 minutos)'
            },
            loadingTexts: {
                loading: 'A gerar o curso para si...',
                pleaseWait: 'Por favor aguarde...',
                courseWillBeReadySoon: 'O seu curso estará pronto em breve...',
                aBitMorePatience: 'Só mais um pouco de paciência...',
                itMightTakeABitLongerButItsWorthIt: 'Isto pode demorar mais alguns segundos, mas valerá a pena...',
            },
        },
        aiWizard: {
            openWizardButton: 'Criar Curso com IA',
            wizardTitle: 'Assistente de Geração de Cursos com IA',
            step1Label: 'Detalhes do Curso',
            step2Label: 'Selecionar Modelo',
            subjectLabel: 'Assunto do Curso',
            subjectPlaceholder: 'Introduza o tema principal do seu curso...',
            promptLabel: 'Instruções Adicionais para a IA (Opcional)',
            promptPlaceholder: 'Forneça instruções específicas para a IA...',
            uploadFileButton: 'Carregar Ficheiro de Referência (PDF/TXT)',
            fileUploaded: 'Ficheiro carregado: {fileName}',
            removeFile: 'Remover ficheiro',
            characterLimitExceeded: 'Limite de caracteres excedido. Por favor reduza o conteúdo.',
            subjectRequired: 'O assunto do curso é obrigatório',
            validationError: 'Por favor corrija os erros antes de continuar',
            fileTooLarge: 'Ficheiro demasiado grande. Tamanho máximo: {maxSize}MB',
            unsupportedFileType: 'Tipo de ficheiro não suportado. Por favor carregue um ficheiro PDF ou TXT',
            fileReadError: 'Erro ao ler o ficheiro. Por favor tente novamente',
            extractingFile: 'A extrair texto do ficheiro...',
            extractError: 'Erro ao extrair texto do ficheiro',
            generateButton: 'Gerar Curso',
            generatingButton: 'A gerar...',
        },
        aiContextGenerator: {
            title: 'Contexto de IA',
        },
        content: {
            title: 'Título',
            description: 'Descrição',
            text: 'Conteúdo de Texto',
            videoUrl: 'URL do Vídeo',
            addQuestion: 'Adicionar Pergunta',
            question: 'Pergunta',
            option: 'Opção {number}',
            correctAnswer: 'Resposta Correta'
        },
        editor: {
            pagination: {
                pageInfo: (key, {current, total}) => `Página ${current} de ${total}`
            },
            backgroundSelector: {
                image: 'Imagem',
                video: 'Vídeo'
            },
            addSection: 'Adicionar Secção',
            editSection: 'Editar Secção',
            preview: 'Pré-visualizar',
            switchToViewMode: 'Mudar para modo de visualização',
            switchToEditMode: 'Mudar para modo de edição',
            enterFullscreen: 'Ecrã inteiro',
            exitFullscreen: 'Sair do ecrã inteiro',
            saveCourse: 'Guardar Curso',
            saveCourseSubTitle: 'Clique para guardar o curso',
            previewMode: 'Modo de Pré-visualização',
            editMode: 'Modo de Edição',
            templateMode: 'Modo de Modelo',
            courseMode: 'Modo de Curso',
            switchToTemplateMode: 'Mudar para Modo de Modelo',
            switchToCourseMode: 'Mudar para Modo de Curso',
            templateDetails: 'Configuração do Modelo de Curso',
            templateName: 'Nome do Modelo',
            templateSubject: 'Categoria / Área Temática',
            templateDescription: 'Descrição do modelo',
            templateTags: 'Etiquetas (separadas por vírgula)',
            templatePublic: 'Acessível Publicamente',
            templateReady: 'Pronto para Utilização',
            saveTemplate: 'Guardar Modelo',
            templateValidationError: 'O nome e o assunto do modelo são obrigatórios',
            templateSaved: 'Modelo guardado com sucesso!',
            templateUpdated: 'Modelo atualizado com sucesso!',
            templateSaveError: 'Erro ao guardar o modelo. Por favor tente novamente.',
            templateCreateError: 'Erro ao criar novo modelo. Por favor tente novamente.',
            fetchError: 'Erro ao carregar o curso ou modelo. Por favor tente novamente.',
            defaultCourseTitle: 'Curso',
            defaultCourseDescription: '',
            templateNamePlaceholder: 'Introduza um título descritivo para este modelo',
            templateSubjectPlaceholder: 'Ex.: Formação em Segurança, Integração, Liderança',
            templateDescriptionPlaceholder: 'Forneça uma descrição detalhada do que este modelo abrange e para quem foi concebido',
            templateTagsPlaceholder: 'Adicione palavras-chave para ajudar os utilizadores a encontrar este modelo (separadas por vírgula)',
            templateSelectorTitle: 'Criar ou Selecionar um Modelo',
            createNewTemplate: 'Criar Novo Modelo',
            createNewTemplateDesc: 'Comece com um modelo em branco e construa-o do zero.',
            createTemplate: 'Criar Modelo',
            selectExistingTemplate: 'Selecionar Modelo Existente',
            selectExistingTemplateDesc: 'Escolha entre os seus modelos existentes para editar.',
            browseTemplates: 'Explorar Modelos',
            publicAssetBank: 'Banco de Recursos Públicos',
            publicAssetBankDescription: 'Os recursos adicionados aqui estarão disponíveis para todos os modelos',
            uploadPublicAsset: 'Carregar Recurso Público',
            publicAssetUploaded: 'Recurso público carregado com sucesso!',
            publicAssetUploadError: 'Erro ao carregar o recurso público. Por favor tente novamente.',
            templateAssetName: 'Recurso do Modelo',
            templateAssetDescription: 'Carregado a partir do editor de modelos',
            componentBank: {
                title: 'Banco de Componentes',
                description: 'Arraste ou clique para adicionar componentes',
                text: {
                    name: 'Texto',
                    description: 'Componente de texto simples'
                },
                bullets: {
                    name: 'Marcadores',
                    description: 'Componente de lista com marcadores'
                },
                logo: {
                    name: 'Logótipo',
                    description: 'Componente de logótipo da empresa',
                    missingLogo: 'O logótipo da empresa está em falta'
                },
                image: {
                    name: 'Imagem',
                    description: 'Componente de imagem'
                },
                video: {
                    name: 'Vídeo',
                    description: 'Componente de vídeo'
                },
                shape: {
                    name: 'Forma',
                    description: 'Componente de formas básicas'
                },
                question: {
                    name: 'Pergunta',
                    description: 'Componente de pergunta interativa'
                }
            },
            chapterEditor: {
                title: 'Editor de Capítulo',
                description: 'Edite o conteúdo do seu capítulo',
                contentTitle: 'Tela',
                canvasDescription: 'Arraste componentes para a tela e posicione-os livremente',
                emptyState: 'Nenhum componente adicionado ainda. Arraste componentes do banco ou clique para adicionar.',
                removeComponent: 'Remover Componente'
            },
            textComponent: {
                placeholder: 'Introduza o seu texto aqui...',
                emptyState: 'Clique para adicionar texto'
            },
            bulletsComponent: {
                placeholder: 'Introduza o texto do ponto...',
                emptyState: 'Ponto vazio',
                removeBullet: 'Remover ponto',
                addBullet: 'Adicionar ponto'
            },
            logoComponent: {
                altText: 'Logótipo da Empresa',
                missingLogo: 'O logótipo da empresa está em falta',
                borderRadius: 'Raio do Contorno',
                backgroundColor: 'Cor de Fundo',
                opacity: 'Opacidade'
            },
            imageComponent: {
                altText: 'Imagem',
                placeholder: 'Clique para adicionar imagem',
                selectorTitle: 'Selecionar Imagem',
                uploadNew: 'Carregar Nova',
                imageBank: 'Banco de Imagens',
                loading: 'A carregar...',
                emptyBank: 'Sem imagens no banco',
                cancel: 'Cancelar',
                enterUrl: 'Introduzir URL',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'Submeter',
                changeSource: 'Alterar Imagem'
            },
            backgroundImageComponent: {
                altText: 'Imagem de Fundo',
                placeholder: 'Clique para adicionar imagem de fundo',
                selectorTitle: 'Selecionar Imagem de Fundo',
                uploadNew: 'Carregar Nova',
                imageBank: 'Banco de Imagens',
                loading: 'A carregar...',
                emptyBank: 'Sem imagens no banco',
                cancel: 'Cancelar',
                enterUrl: 'Introduzir URL',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'Submeter',
                changeSource: 'Alterar Imagem de Fundo'
            },
            videoComponent: {
                altText: 'Vídeo',
                placeholder: 'Clique para adicionar vídeo',
                selectorTitle: 'Selecionar Vídeo',
                uploadNew: 'Carregar Novo',
                videoBank: 'Banco de Vídeos',
                loading: 'A carregar...',
                emptyBank: 'Sem vídeos no banco',
                cancel: 'Cancelar',
                enterUrl: 'Introduzir URL',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'Submeter',
                changeSource: 'Alterar Vídeo',
                errorTitle: 'Falha ao Carregar o Vídeo',
                errorMessage: 'Não foi possível carregar o vídeo. Carregue um novo vídeo ou selecione outro do banco de vídeos.',
                retry: 'Tentar Novamente',
                selectAnother: 'Selecionar Outro Vídeo',
                edit: 'Editar'
            },
            shapeComponent: {
                emptyState: 'Clique para selecionar uma forma',
                rectangle: 'Retângulo',
                circle: 'Círculo',
                triangle: 'Triângulo',
                star: 'Estrela'
            },
            color: {
                placeholder: '#000000'
            },
            component: {
                borderRadius: 'Raio do Contorno',
                backgroundColor: 'Cor de Fundo',
                opacity: 'Opacidade',
                textDirection: 'Direção do Texto',
                leftToRight: 'Esquerda para Direita',
                rightToLeft: 'Direita para Esquerda',
                pixelUnit: 'px',
                percentUnit: '%',
                colorValue: (key, { color }) => color,
                backgroundColorValue: (key, { color }) => color,
                borderRadiusAll: 'Todos'
            },
            editorDrawer: {
                title: 'Editar Componente',
                closeButton: 'Fechar',
                description: 'Personalize o componente selecionado',
                typography: 'Tipografia',
                textFormatting: 'Formatação de Texto',
                fontSize: 'Tamanho da Fonte',
                textColor: 'Cor do Texto',
                shapeType: 'Tipo de Forma',
                shapeColor: 'Cor da Forma',
                shapeBackground: 'Fundo da Forma',
                colorMode: 'Cor',
                gradientMode: 'Gradiente',
                gradientColor1: 'Primeira Cor',
                gradientColor2: 'Segunda Cor',
                gradientAngle: 'Ângulo do Gradiente',
                borderGradientColor1: 'Primeira Cor',
                borderGradientColor2: 'Segunda Cor',
                borderGradientAngle: 'Ângulo do Gradiente',
                shapeOpacity: 'Opacidade da Forma',
                borderWidth: 'Largura do Contorno',
                borderColor: 'Cor do Contorno',
                border: 'Contorno',
                style: 'Estilo',
                background: 'Fundo'
            },
            backgroundImage: {
                label: 'Imagem de Fundo',
                placeholder: 'Introduza o URL da imagem',
                uploadButton: 'Carregar Imagem',
                previewAlt: 'Pré-visualização do Fundo',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=Invalid+Image+URL'
            },
            logoImage: {
                label: 'Logótipo',
                placeholder: 'Introduza o URL do logótipo',
                uploadButton: 'Carregar Logótipo',
                previewAlt: 'Pré-visualização do Logótipo',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=Invalid+Logo+URL'
            },
            backgroundImageEditor: {
                title: 'Editar Imagem de Fundo',
                opacity: 'Opacidade',
                backgroundColor: 'Cor de Fundo',
                transparent: 'Transparente',
                save: 'Guardar Alterações',
                remove: 'Remover Imagem de Fundo',
                cancel: 'Cancelar'
            },
            backgroundVideoEditor: {
                title: 'Editar Vídeo de Fundo',
                opacity: 'Opacidade',
                backgroundColor: 'Cor de Fundo',
                transparent: 'Transparente',
                save: 'Guardar Alterações',
                remove: 'Remover Vídeo de Fundo',
                cancel: 'Cancelar'
            },
            backgroundVideoComponent: {
                changeSource: 'Alterar Fonte do Vídeo',
                enterUrl: 'Introduzir URL do Vídeo',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'Aplicar',
                cancel: 'Cancelar',
                uploadNew: 'Carregar Novo Vídeo',
                loading: 'A carregar...',
                videoBank: 'Banco de Vídeos',
                backgroundVideoBank: 'Banco de Vídeos de Fundo',
                emptyBank: 'Não foram encontrados vídeos no banco de vídeos.'
            },
            videoUrl: {
                label: 'URL do Vídeo',
                placeholder: 'Introduza o URL do YouTube ou de vídeo'
            },
            // Default values for new chapters
            headTitle: {
                label: 'Título Principal',
                defaultValue: 'Novo Capítulo'
            },
            textContent: {
                label: 'Conteúdo de Texto',
                defaultValue: 'Introduza o seu conteúdo aqui',
                placeholder: 'Introduza o seu conteúdo aqui'
            },
            bullets: {
                defaultValue1: 'Ponto 1',
                defaultValue2: 'Ponto 2',
                defaultValue3: 'Ponto 3'
            },
            title: {
                defaultValue: 'Novo Capítulo'
            },
            description: {
                defaultValue: 'Descrição do capítulo'
            },
            // Template selection
            templateSelectionInstruction: 'Selecione um modelo para o seu novo capítulo:',
            featureBadges: {
                video: 'Vídeo',
                bullets: 'Marcadores',
                textContent: 'Conteúdo de Texto',
                'text-content': 'Conteúdo de Texto',
                heading: 'Título'
            }
        },
        templateBank: {
            title: 'Escolher um Modelo',
            description: 'Selecione um modelo para o seu novo capítulo',
            closeButton: 'Fechar banco de modelos',
            selectTemplate: (key, { templateName }) => `Selecionar modelo ${templateName}`,
            directionSelection: 'Selecionar direção do modelo:',
            ltrDirection: 'Direção da esquerda para a direita',
            rtlDirection: 'Direção da direita para a esquerda',
            ltrLabel: 'LTR',
            rtlLabel: 'RTL',
            templates: {
                standardSlide: {
                    name: 'Diapositivo Padrão',
                    description: 'Um diapositivo padrão com logótipo, título, texto à direita e imagem à esquerda'
                },
                videoFocused: {
                    name: 'Foco em Vídeo',
                    description: 'Um diapositivo com um vídeo grande ao centro e texto de apoio abaixo'
                },
                bulletPoints: {
                    name: 'Marcadores',
                    description: 'Um diapositivo centrado em marcadores para informação-chave'
                },
                centeredImage: {
                    name: 'Imagem Centrada',
                    description: 'Um diapositivo com uma imagem grande centrada e texto de legenda abaixo'
                },
                textAndBullets: {
                    name: 'Texto e Marcadores',
                    description: 'Um diapositivo com texto à esquerda e marcadores à direita'
                },
                videoAndBullets: {
                    name: 'Vídeo e Marcadores',
                    description: 'Um diapositivo com um vídeo à esquerda e marcadores à direita'
                },
                twoColumnImage: {
                    name: 'Imagem em Duas Colunas',
                    description: 'Um diapositivo com duas imagens lado a lado e uma legenda abaixo'
                },
                threeColumnText: {
                    name: 'Texto em Três Colunas',
                    description: 'Um diapositivo com três colunas de texto para comparar ou listar informação relacionada'
                },
                imageGallery: {
                    name: 'Galeria de Imagens',
                    description: 'Um diapositivo com quatro imagens dispostas em grelha e uma legenda abaixo'
                },
                videoWithOverlay: {
                    name: 'Vídeo com Sobreposição',
                    description: 'Um diapositivo com um vídeo e sobreposição de texto para destacar pontos-chave'
                },
                titleWithBackground: {
                    name: 'Título com Fundo',
                    description: 'Um diapositivo com título e texto sobre uma imagem de fundo para efeito dramático'
                }
            },
            content: {
                slideTitle: 'Título do Diapositivo',
                loremIpsum: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam auctor, nisl eget ultricies tincidunt, nisl nisl aliquam nisl, eget ultricies nisl nisl eget nisl.',
                videoTitle: 'Apresentação em Vídeo',
                videoDescription: 'Este vídeo explica os conceitos-chave do tema. Veja-o com atenção para compreender as ideias principais.',
                bulletTitle: 'Pontos-Chave',
                bullet1: 'Primeiro ponto importante a recordar sobre este tema',
                bullet2: 'Segundo conceito-chave que se baseia no primeiro ponto',
                bullet3: 'Terceiro elemento essencial que completa a compreensão',
                imageTitle: 'Representação Visual',
                imageCaption: 'Esta imagem ilustra o conceito descrito neste capítulo. Estude-a com atenção para compreender os elementos visuais.',
                textBulletTitle: 'Visão Geral do Conceito',
                textContent: 'Esta secção fornece uma explicação detalhada do conceito. O texto apresenta as ideias principais e fornece contexto para compreender os pontos-chave listados à direita.',
                textBullet1: 'Ponto-chave relacionado com o conceito explicado no texto',
                textBullet2: 'Informação adicional que apoia o conceito principal',
                textBullet3: 'Ponto final que completa a compreensão do tema',
                videoBulletTitle: 'Tutorial em Vídeo com Pontos-Chave',
                videoBullet1: 'Veja o vídeo para compreender a demonstração',
                videoBullet2: 'Acompanhe os passos mostrados no vídeo',
                videoBullet3: 'Consulte estes marcadores enquanto assiste ao vídeo',

                // Two-column image template content
                twoColumnImageTitle: 'Comparação de Imagens',
                twoColumnImageCaption: 'Estas imagens ilustram diferentes aspetos do conceito. Compare-as para compreender as principais diferenças e semelhanças.',

                // Three-column text template content
                threeColumnTitle: 'Processo em Três Etapas',
                column1Text: 'Etapa 1: Comece por compreender os princípios básicos e os fundamentos do conceito. Esta fase inicial é crucial para construir uma compreensão sólida.',
                column2Text: 'Etapa 2: Aplique os princípios em cenários práticos e explore como interagem com situações do mundo real. A prática é essencial para a mestria.',
                column3Text: 'Etapa 3: Avalie a sua compreensão e refine a sua abordagem com base no feedback e nos resultados. A melhoria contínua conduz à especialização.',

                // Image gallery template content
                imageGalleryTitle: 'Galeria de Exemplos Visuais',
                imageGalleryCaption: 'Esta coleção de imagens demonstra vários aspetos do tema. Cada imagem representa um exemplo ou aplicação diferente.',

                // Video with overlay template content
                videoOverlayTitle: 'Vídeo com Destaques Principais',
                videoOverlayText: 'IMPORTANTE: Preste especial atenção a esta demonstração, pois mostra técnicas essenciais.',

                // Title with background template content
                backgroundTitle: 'Visão Geral do Capítulo',
                backgroundSubtitle: 'Conceitos e princípios essenciais',
                backgroundText: 'Este capítulo apresenta conceitos fundamentais que formam a base do tema. Compreender estes princípios é crucial para dominar os tópicos mais avançados que se seguem.'
            }
        },
        courseTemplateBank: {
            title: 'Criar Curso com IA',
            description: 'Selecione um modelo de curso para criar um novo curso com conteúdo gerado por IA',
            courseTemplatesTitle: 'Modelos de Curso',
            chapterTemplatesTitle: (key, { count }) => `Diapositivos Incluídos (${count})`,
            slideCount: (key, { count }) => `${count} diapositivos`,
            defaultCourseTitle: 'Novo Curso',
            defaultCourseDescription: 'Curso criado com IA',
            defaultSectionTitle: 'Secção 1',
            cancelButton: 'Cancelar',
            createButton: 'Criar Curso',
            yourDescription: 'Descrição do Seu Curso:',
            defaultTemplatesTab: 'Modelos Predefinidos',
            designedTemplatesTab: 'Modelos Concebidos',
            loadingTemplates: 'A carregar modelos...',
            noDesignedTemplates: 'Não existem modelos concebidos disponíveis de momento.',
            estimatedDuration: (key, { duration }) => `${duration} min`,
            noDescription: 'Sem descrição disponível',
            noPreviewAvailable: 'Sem pré-visualização disponível',
            generationStartError: 'Ocorreu um erro ao iniciar a geração do curso. Por favor, tente novamente.',
            courseTypes: {
                business: 'Empresarial',
                technical: 'Técnico',
                educational: 'Educacional',
                onboarding: 'Integração',
                compliance: 'Conformidade',
                product: 'Produto'
            },
            templates: {
                businessCourse: {
                    name: 'Curso Empresarial',
                    description: 'Um modelo abrangente de curso empresarial com diapositivos que abrangem conceitos-chave de negócio, estratégias e estudos de caso'
                },
                technicalCourse: {
                    name: 'Curso Técnico',
                    description: 'Um modelo detalhado de curso técnico com diapositivos que abrangem conceitos técnicos, demonstrações e exemplos práticos'
                },
                educationalCourse: {
                    name: 'Curso Educacional',
                    description: 'Um modelo de curso educacional estruturado com diapositivos concebidos para uma aprendizagem eficaz e retenção do conhecimento'
                },
                onboardingCourse: {
                    name: 'Curso de Integração',
                    description: 'Um modelo de curso de integração com diapositivos para apresentar aos novos colaboradores as políticas, procedimentos e cultura da empresa'
                },
                complianceCourse: {
                    name: 'Curso de Conformidade',
                    description: 'Um modelo de curso de conformidade com diapositivos que abrangem requisitos regulamentares, boas práticas e procedimentos de conformidade'
                },
                productCourse: {
                    name: 'Curso de Produto',
                    description: 'Um modelo de curso de formação sobre produto com diapositivos que apresentam funcionalidades, benefícios e exemplos de utilização do produto'
                }
            }
        }
    },
    AIGeneration: {
        titles: {
            WEEZBEE_COURSE: 'Criar Curso com IA',
            EXAM: 'Criar Exame com IA',
            SURVEY: 'Criar Inquérito com IA',
            default: 'Criar Conteúdo com IA',
        },
        buttonText: {
            WEEZBEE_COURSE: 'Criar Curso com IA',
            EXAM: 'Gerar Perguntas com IA',
            SURVEY: 'Gerar Perguntas com IA',
            default: 'Criar com IA',
        }
    },
    questionnaireSession: {
        imageLoadError: 'Falha ao carregar imagem',
        modal: {
            finishExam: 'Tem a certeza de que pretende terminar o exame?',
            finishExamTitle: 'Terminar Exame',
            finishExamWithUnansweredQuestions: 'Tem a certeza de que pretende terminar? Existem perguntas sem resposta',
            closeAndReturnToTest: 'Voltar ao exame'
        },
        finishModal: {
            congratsTitle: 'Muito bem!',
            congratsMessage: 'Passou no exame com sucesso',
            oopsTitle: 'Ups...',
            oopsMessage: 'Parece que não passou no exame',
        },
        buttons: {
            previousQuestion: 'Pergunta anterior',
            nextQuestion: 'Pergunta seguinte',
            finishExam: 'Terminar exame',
            congratsModal: 'Ótimo, leve-me ao ecrã inicial',
            oopsBackToHomePage: 'Voltar ao ecrã inicial',
        },
        errors: {
            notAllQuestionsAnswered: 'Nem todas as perguntas foram respondidas. Tem a certeza de que pretende terminar?',
        },
    },
    surveySession: {
        finishModal: {
            congratsTitle: 'Obrigado!',
            congratsMessage: 'Obrigado por participar no inquérito! \n A sua contribuição é muito importante para nós.',
        },
        defaultTitle: "Inquérito",
        buttons: {
            previousQuestion: "Pergunta anterior",
            nextQuestion: "Pergunta seguinte",
            finishSurvey: "Terminar Inquérito",
            congratsModal: 'Ótimo, leve-me ao ecrã inicial',
        },
        placeHolders: {
            FREE_TEXT: 'A sua resposta',
        },
        modal: {
            finishSurveyTitle: "Terminar Inquérito",
            finishSurvey: "Tem a certeza de que pretende terminar o inquérito? Pode voltar atrás e alterar as respostas antes de terminar.",
            closeAndReturnToSurvey: "Voltar ao inquérito"
        },
        success: {
            title: "Obrigado!",
            anonymousMessage: "As suas respostas foram guardadas anonimamente",
            identifiedMessage: "As suas respostas foram guardadas com sucesso no sistema",
            thankYou: "Obrigado por participar no inquérito! A sua contribuição é muito importante para nós.",
            anonymousConfirmation: "As suas informações foram guardadas anonimamente e não é possível identificá-lo",
            goHome: "Voltar à página inicial"
        }
    },
    surveyInstruction: {
        title: 'Antes de começarmos, algumas notas...',
        info1: (key, { numberOfQuestions }) => `O inquérito é composto por ${numberOfQuestions} perguntas`,
        info2: 'Adoraríamos ouvir a sua opinião',
        info3: 'A participação no inquérito é voluntária',
        info4: 'Pode ignorar as perguntas que preferir não responder',
        anonymous: 'O inquérito é completamente anónimo',
        anonymousNotice: 'As suas respostas são guardadas anonimamente e não podem ser associadas a si',
        thankYou: 'Obrigado pela sua participação!',
        startButton: 'Iniciar Inquérito'
    },
    questionnaireInstruction: {
        title: 'Antes de começarmos, algumas notas...',
        info1: (key, { numberOfQuestions }) => `O exame é composto por ${numberOfQuestions} perguntas`,
        info2: (key, { passGrade }) => `Nota de aprovação do exame - ${passGrade}`,
        info3: 'Por favor, responda a todas as perguntas antes de submeter',
        successInfo: 'Passou? ',
        failInfo: "Não passou? ",
        info4: 'Parabéns, concluiu a tarefa. ',
        info5: 'É necessário repetir',
        goodLuck: 'Boa sorte!',
        startButton: 'Iniciar'
    },
    signDoc: {
        finishByDuration: {
            toggleLabel: 'Definir tempo para concluir a tarefa',
            title: 'Tempo para Concluir',
            note: 'Número de dias que o utilizador tem para concluir a tarefa a partir do momento da atribuição'
        },
        assignmentWarning: {
            title: 'Aviso de Atribuição',
            editingWillBeLocked: 'Aviso: Uma vez que este documento seja atribuído a unidades organizacionais, a edição de perguntas ficará bloqueada para preservar a integridade da formação.',
            editingLocked: 'Atenção: A edição de perguntas não é permitida devido a atribuições anteriores a unidades organizacionais.',
            continueAssignment: 'Continuar Atribuição',
            cancel: 'Cancelar'
        },
        editDisabled: {
            assignedToOrganizations: 'A edição está desativada porque este documento foi atribuído a unidades organizacionais. Isto preserva a integridade da formação e garante uma avaliação consistente.',
            editQuestionsDisabled: 'A edição de perguntas está desativada para documentos atribuídos a unidades organizacionais'
        },
        duplicate: {
            button: 'Duplicar como Cópia Editável',
            modal: {
                title: 'Duplicar SignDoc',
                description: 'Criar uma nova cópia editável deste documento com todas as suas perguntas.',
                newNameLabel: 'Nome do Novo Documento',
                newNamePlaceholder: 'Cópia de {originalName}',
                newDescriptionLabel: 'Descrição do Novo Documento (Opcional)',
                newDescriptionPlaceholder: 'Cópia do documento original',
                duplicate: 'Criar Duplicado',
                cancel: 'Cancelar'
            },
            success: 'Documento duplicado com sucesso! Já pode editar a nova cópia.',
            error: 'Falha ao duplicar o documento. Por favor, tente novamente.'
        },
        questionSection: {
            pleaseSelectAnswer: 'Por favor, selecione uma resposta',
            correct: 'Correto! A sua resposta está certa.',
            incorrect: 'Incorreto. Por favor, tente novamente.',
            submitError: 'Erro ao submeter a resposta. Por favor, tente novamente.',
            submit: 'Submeter Resposta',
            alreadyCompleted: 'Já respondeu a esta pergunta com sucesso'
        },
        sequentialActiveVersionModal: {
            title: 'Substituir Versão Ativa?',
            message: (key, {activeVersionName}) => `"${activeVersionName}" é a versão ativa atual para este conteúdo recorrente.`,
            subMessage: 'Apenas uma versão pode estar ativa de cada vez. Ativar esta versão irá arquivar a anterior. Os utilizadores atribuídos à versão anterior também serão atribuídos à nova versão, e a versão anterior aparecerá no seu arquivo.',
            declineButton: 'Cancelar',
            agreeButton: 'Substituir e Ativar'
        }
    },
    learningManagement: {
        createEditNewSignDocModal: {
            approversSection: {
                title: 'Selecionar Aprovadores (Opcional)',
                description: 'Selecione utilizadores específicos que podem aprovar carregamentos. Se não selecionar nenhum, todos os administradores das unidades organizacionais atribuídas serão os aprovadores.',
                userLabel: 'Selecionar utilizadores específicos como aprovadores',
                defaultInfo: 'Se não forem selecionados utilizadores específicos, apenas você ou os administradores da empresa poderão aprovar carregamentos'
            },
            individualUsersSection: {
                title: 'Atribuir a Utilizadores Individuais',
                userLabel: 'Pesquisar utilizadores para atribuição individual',
                searchLabel: 'Pesquisar Utilizadores',
                searchPlaceholder: 'Digite nome, telefone ou email...',
                noUsersFound: 'Nenhum utilizador encontrado na sua pesquisa',
            },
            // Organization search
            organizationsSection: {
                searchLabel: 'Pesquisar Unidade Organizacional',
                searchPlaceholder: 'Digite o nome da unidade organizacional...',
            },
            // User pagination labels
            noUsers: 'Nenhum utilizador encontrado',
            selectedLabel: 'utilizadores selecionados',
            noOrganizations: 'Nenhuma unidade organizacional encontrada',
            selectedOrgsLabel: 'unidades organizacionais selecionadas',
            userPaginationError: 'Erro ao Carregar Utilizadores',
            userPaginationErrorMessage: 'Não foi possível carregar a lista de utilizadores. Por favor, tente novamente usando as setas de navegação.',
            orgPaginationError: 'Erro ao Carregar Unidades Organizacionais',
            orgPaginationErrorMessage: 'Não foi possível carregar a lista de unidades organizacionais. Por favor, tente novamente usando as setas de navegação.',
            uploadError: 'Falha no Carregamento do Ficheiro',
            uploadErrorMessage: 'O carregamento falhou. Por favor, tente novamente.'
        }
    },
    pendingApprovals: {
        title: 'Aprovações Pendentes',
        description: 'Reveja e aprove ou rejeite os carregamentos de documentos dos utilizadores',
        searchPlaceholder: 'Pesquisar por nome do utilizador ou tarefa...',
        noData: 'Sem aprovações pendentes',
        tabs: {
            documentApprovals: 'Aprovações de Documentos',
            courseAttendance: 'Presença em Cursos'
        },
        columns: {
            userName: 'Nome do Utilizador',
            phone: 'Telefone',
            idNumber: 'Número de Identificação',
            signDocName: 'Nome da Tarefa',
            uploadDate: 'Data de Carregamento',
            organization: 'Unidade Organizacional',
            files: 'Ficheiros',
            actions: 'Ações'
        },
        actions: {
            approve: 'Aprovar',
            reject: 'Rejeitar'
        },
        approveDialog: {
            title: 'Aprovar Carregamento',
            user: 'Utilizador',
            signDoc: 'Tarefa',
            confirmMessage: 'Aprovar este carregamento?',
            expiryDescription: 'Esta certificação requer a introdução manual da data de validade. Selecione a data em que a certificação irá expirar.',
            expiryDateLabel: 'Data de Validade da Certificação',
            expiryDateRequired: 'A data de validade é obrigatória para a certificação',
            expiryDatePast: 'A data de validade deve ser no futuro',
            cancel: 'Cancelar',
            confirm: 'Aprovar Carregamento'
        },
        rejectDialog: {
            title: 'Rejeitar Carregamento',
            reasonLabel: 'Motivo de Rejeição (Opcional)',
            reasonPlaceholder: 'Explique ao utilizador por que o carregamento foi rejeitado...',
            deleteFilesLabel: 'Eliminar ficheiros carregados do servidor',
            cancel: 'Cancelar',
            confirm: 'Rejeitar Carregamento'
        },
        errors: {
            approveFailed: 'Erro ao aprovar o carregamento. Por favor, tente novamente.',
            rejectFailed: 'Erro ao rejeitar o carregamento. Por favor, tente novamente.'
        }
    },
    courseAttendance: {
        title: 'Presença em Cursos',
        description: 'Marque a presença ou falta para utilizadores inscritos em cursos',
        searchPlaceholder: 'Pesquisar por nome do utilizador ou curso...',
        noData: 'Sem cursos com marcação de presença pendente',
        columns: {
            userName: 'Nome do Utilizador',
            phone: 'Telefone',
            idNumber: 'Número de Identificação',
            courseName: 'Nome do Curso',
            courseType: 'Tipo de Curso',
            sessionDate: 'Data da Sessão',
            actions: 'Ações'
        },
        courseTypes: {
            frontal: 'Presencial',
            online: 'Online'
        },
        actions: {
            markAttended: 'Marcar Presença',
            markNoShow: 'Marcar Falta'
        },
        tooltips: {
            sessionNotToday: 'A presença só pode ser marcada no dia da sessão'
        },
        errors: {
            markAttendedFailed: 'Erro ao marcar presença. Por favor, tente novamente.',
            markNoShowFailed: 'Erro ao marcar falta. Por favor, tente novamente.'
        },
        filters: {
            allCourses: 'Todos os Cursos'
        }
    },
    partnersTable:{
        columns: {
            partnerName: 'Nome do Parceiro',
            generateAPIKey: 'Gerar Chave API',
            edit: 'Editar',
        }
    },
    reports: {
        title: 'Relatórios',
        tabs: {
          companies: 'Empresas',
        },
        companiesInfo: {
            totalUsersCount: 'Total de utilizadores ativos no sistema',
            newUsersThisMonthCount: 'Novos utilizadores este mês',
            totalCompaniesCount: 'Total de empresas no sistema',
            newCompaniesThisMonthCount: 'Novas empresas este mês',
            columns: {
                companyName: 'Nome da Empresa',
                userQuota: 'Quota de Utilizadores',
                activeUsers: 'Utilizadores Ativos',
                createdAt: 'Criado Em',
                organizations: 'Número de Unidades Organizacionais',
                admins: 'Número de Administradores do Sistema',
                courses: 'Número de Cursos e Documentos',
                assignmentCompletion: 'Percentagem de Conclusão de Tarefas',
                lastMemoSentDate: 'Data do Último Lembrete Enviado',
                smsCount: 'Número de Mensagens Enviadas',
                smsQuota: 'Número de Mensagens Restantes',
                lastAdminLoginDate: 'Data do Último Início de Sessão do Administrador',
                adminIdentifier: 'Identificador do Administrador',
            }
        }
    },
    learningPath: {
        sequentialOnlyDisclaimer: 'Este percurso de aprendizagem está definido como "recorrente" - apenas tarefas recorrentes podem ser adicionadas',
        freePath: {
            checkboxLabel: 'Percurso livre — escolha as tarefas em qualquer ordem',
            checkboxHelper: 'Quando ativado, os utilizadores atribuídos podem iniciar qualquer tarefa imediatamente e concluí-las em qualquer ordem. Quando desativado, as tarefas devem ser concluídas sequencialmente.',
            adminBanner: 'O modo de percurso livre está ativado. Os utilizadores atribuídos podem concluir as tarefas em qualquer ordem.',
            confirmSwitchToOrderedTitle: 'Mudar para ordem sequencial de tarefas?',
            confirmSwitchToOrderedBody: 'Este percurso de aprendizagem está atualmente em ordem livre e já foi atribuído. Mudar para sequencial significa que os utilizadores atribuídos serão obrigados a concluir as tarefas na ordem definida. Os utilizadores que já concluíram tarefas fora de ordem manterão o seu progresso, mas a sua próxima tarefa disponível será a primeira incompleta na sequência — o que pode parecer inesperado. Tem a certeza?',
            confirmSwitchToOrderedConfirm: 'Mudar para sequencial',
            badge: 'Percurso livre',
        },
    },
    HoneycombTasks: {
        servicesText: {
            READ_AND_SIGN_DOC_PDF: 'Documento',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Vídeo',
            WATCH_AND_SIGN_VIMEO_LINK: 'Vídeo',
            WATCH_AND_SIGN_VIDEO_FILE: 'Vídeo',
            AUDIO_FILE: 'Ficheiro de Áudio',
            REGULAR_COURSE: 'Curso',
            CANVA_PRESENTATION: 'Apresentação',
            EXAM: 'Exame',
            LEARNING_PATH: 'Percurso de Aprendizagem',
            PODCAST: 'Podcast',
            FRONTAL_COURSE: 'Aula Presencial',
            ONLINE_COURSE: 'Curso Online',
            PRESENTATION: 'Apresentação',
            ARTICLE: 'Artigo',
            SURVEY: 'Inquérito',
            LINK: 'Ligação',
            UPLOAD_DOCUMENT: 'Carregar Documento',
        },
    },
    userProgressReport: {
        exportToExcel: 'Exportar para Excel',
        exporting: 'A exportar...',
        exportCurrentFilters: 'Exportar filtros actuais',
        columns: {
            fullName: 'Nome Completo',
            firstName: 'Primeiro Nome',
            lastName: 'Apelido',
            phone: 'Telefone',
            idNumber: 'Número de Identificação',
            employeeId: 'ID de Colaborador',
            chosenOrganizationUnitsProgress: 'Progresso de Tarefas nas Unidades Seleccionadas',
            allManagedProgress: 'Progresso em Todas as Tarefas',
            completionStatus: 'Estado de Conclusão',
            organizations: 'Unidades Organizacionais',
            userDetails: 'Detalhes do Utilizador'
        },
        completionStatus: (key, { completed, total }) => `${completed} de ${total} concluídas`,
        tasksCompleted: 'tarefas concluídas',
        pieChart: {
            title: 'Desempenho Global dos Colaboradores nas Tarefas da Organização',
            subtitle: 'Distribuição de Tarefas por Estado',
            selectedOrgsTitle: 'Percentagem de Progresso dos Colaboradores nas Unidades Seleccionadas',
            selectedOrgsSubtitle: 'Distribuição de Tarefas nas Unidades Seleccionadas',
            selectedOrgsInfoBubble: 'Este gráfico mostra a distribuição de tarefas dos colaboradores nas unidades organizacionais seleccionadas nos filtros. Inclui apenas tarefas atribuídas a colaboradores nas unidades seleccionadas.',
            allManagedTitle: 'Percentagem Global de Progresso de Tarefas dos Colaboradores nas Unidades Seleccionadas',
            allManagedSubtitle: 'Distribuição de Todas as Tarefas sob Gestão',
            allManagedInfoBubble: 'Este gráfico mostra a distribuição de todas as tarefas dos colaboradores em todas as unidades organizacionais que gere, independentemente dos filtros seleccionados. Fornece uma visão abrangente de todas as tarefas sob a sua gestão.',
            completed: 'Tarefas Concluídas',
            inProgress: 'Tarefas em Progresso',
            notStarted: 'Tarefas Não Iniciadas',
            totalTasks: (key, { count = 0 } = {}) => `Total: ${count} tarefas`
        }
    },
    certificationDashboard: {
        title: 'Painel de Certificação',
        subtitle: 'Acompanhe o estado de certificação e a validade dos utilizadores',
        tasksCompleted: 'Concluído',
        columns: {
            fullName: 'Nome Completo',
            status: 'Estado',
            phone: 'Telefone',
            organizations: 'Unidades Organizacionais',
            idNumber: 'Número de Identificação',
            employeeId: 'ID de Colaborador',
            chosenOrganizationUnitsProgress: 'Progresso das Unidades Organizacionais Seleccionadas',
            allManagedProgress: 'Progresso de Todas as Geridas',
            userDetails: 'Detalhes do Utilizador',
        },
        pieChart: {
            selectedOrgsTitle: 'Estado das Unidades Organizacionais Seleccionadas',
            selectedOrgsSubtitle: 'Distribuição do Estado de Certificação',
            selectedOrgsInfoBubble: 'Estado de certificação das unidades organizacionais seleccionadas',
            allManagedTitle: 'Estado de Todas as Unidades Organizacionais Geridas',
            allManagedSubtitle: 'Distribuição do Estado de Certificação',
            allManagedInfoBubble: 'Estado de certificação de todas as unidades organizacionais geridas',
        }
    },
    certificationStatus: {
        expired: 'Expirado',
        expiringSoon: 'A Expirar em Breve',
        incomplete: 'Incompleto',
        completed: 'Concluído',
    },
    videoPlayer: {
        pleaseEnterVideoUrl: 'Por favor insira o URL do vídeo',
    },
    imageBank: {
        title: 'Banco de Imagens da Empresa',
        noImages: 'Não foram encontradas imagens no banco de imagens da empresa.',
        clickToCopy: 'Clique para copiar o URL',
        urlCopied: 'URL da imagem copiado para a área de transferência!',
        copyFailed: 'Falha ao copiar o URL. Por favor tente manualmente.',
        fetchError: 'Falha ao carregar imagens. Por favor tente novamente mais tarde.',
        featureFlagDisabled: 'A funcionalidade Banco de Imagens não está activada para a sua empresa.'
    },
    course: {
        untitled: 'Curso Sem Título',
        notFound: 'Curso não encontrado. Por favor verifique o URL ou contacte o suporte.',
        fetchError: 'Falha ao carregar o curso. Por favor tente novamente mais tarde.',
        loading: 'A carregar o curso...',
        error: 'Erro ao carregar o curso',
        error: {
            sessionDateRequired: 'Por favor defina a data e hora da sessão do curso antes de atribuir a unidades organizacionais'
        }
    },
    assetBank: {
        title: 'Banco de Recursos da Empresa',
        publicTitle: 'Banco de Recursos Público',
        noImages: 'Não foram encontradas imagens no banco de recursos da empresa.',
        noVideos: 'Não foram encontrados vídeos no banco de recursos da empresa.',
        clickToCopy: 'Clique para copiar o URL',
        urlCopied: 'URL copiado para a área de transferência!',
        copyFailed: 'Falha ao copiar o URL. Por favor tente manualmente.',
        fetchImageError: 'Falha ao carregar imagens. Por favor tente novamente mais tarde.',
        fetchVideoError: 'Falha ao carregar vídeos. Por favor tente novamente mais tarde.',
        imagesTab: 'Imagens',
        videosTab: 'Vídeos',
        featureFlagDisabled: 'A funcionalidade Banco de Recursos não está activada para a sua empresa.',
        addToChapterTooltip: 'Adicionar ao capítulo',
        addToChapter: 'Adicionar ao Capítulo',
        addAsBackgroundTooltip: 'Adicionar como fundo do capítulo',
        addAsBackground: 'Adicionar como Fundo',
        addedToChapter: (key, { type }) => `${type === 'image' ? 'Imagem' : 'Vídeo'} adicionado ao capítulo!`,
        addedAsBackground: 'Imagem adicionada como fundo do capítulo!',
        addedAsBackgroundVideo: 'Vídeo adicionado como fundo do capítulo!',
        uploadImage: 'Carregar Imagem',
        uploadVideo: 'Carregar Vídeo',
        uploadSuccess: 'Ficheiro carregado com sucesso',
        uploadError: 'Erro ao carregar ficheiro',
        invalidFileType: 'Tipo de ficheiro inválido',
        fileTooLarge: (key, { maxSize }) => `O ficheiro é demasiado grande. O tamanho máximo é ${maxSize}`
    },
    certifications: {
        category: 'Categoria',
        categoryForceCompletion: 'Tarefa Obrigatória',
        categoryCertification: 'Certificação',
        categoryKnowledgeCenter: 'Centro de Conhecimento',
        categoryChangeDisabled: {
            multipleVersions: 'Não é possível alterar a categoria quando existem múltiplas versões'
        },
        expiryDuration: {
            toggleLabel: 'Adicionar Validade à Certificação',
            title: 'Validade da Certificação',
            valueLabel: 'Duração',
            unitLabel: 'Unidade de Tempo',
            units: {
                years: 'Anos',
                months: 'Meses',
                days: 'Dias'
            },
            note: 'Defina o período de validade da certificação. O sistema calculará a data de expiração a partir da data de conclusão da certificação.'
        },
    },
    durationPicker: {
        label: 'Duração para concluir',
        valueLabel: 'Quantidade',
        valuePlaceholder: 'Introduza o valor',
        unitPlaceholder: 'Seleccione a unidade',
        days: 'Dias',
        months: 'Meses',
        years: 'Anos',
        MINUTES: 'Minutos',
        DAYS: 'Dias',
        MONTHS: 'Meses',
        YEARS: 'Anos',
        errorInvalidValue: 'Por favor introduza um número positivo'
    },
    courseFields: {
        sessionStartDate: 'Data e Hora de Início da Sessão',
        sessionDuration: 'Duração da Sessão (minutos)',
        location: 'Localização (endereço/sala)',
        meetingLink: 'Link da Reunião (Zoom/Google Meet)',
        instructor: 'Nome do Instrutor',
        onlineSession: 'Sessão Online',
        invalidMeetingLink: 'Por favor introduza um link de reunião válido de uma plataforma reconhecida (Zoom, Microsoft Teams, Google Meet, Webex, GoToMeeting, Jitsi, Whereby, etc.)',
    },
    selectDurationModal: {
        titleOrg: 'Definir Duração para a Unidade Organizacional',
        titleUser: 'Definir Duração para o Utilizador',
        durationLabel: 'Tempo para concluir a tarefa',
        explanation: 'Os utilizadores receberão um prazo calculado a partir da data de atribuição. Por exemplo, se definir 60 dias, um utilizador atribuído hoje terá 60 dias para concluir a tarefa.'
    },
    addToHomeScreen: {
        title: 'Instalar a Aplicação',
        description: 'Instale o WeezBee no seu dispositivo para um acesso mais rápido e uma melhor experiência.',
        install: 'Instalar Agora',
        dismiss: 'Compreendi, obrigado!',
        neverAskAgain: 'Não mostrar novamente',
        benefits: {
            faster: 'Acesso mais rápido',
            offline: 'Funciona sem ligação',
            homeScreen: 'Atalho no ecrã principal'
        },
        iosInstructions: {
            title: 'Para instalar a aplicação no seu iPhone:',
            step1Part1: 'Toque no botão "Partilhar"',
            step1Part2: '- encontrado na barra de URL ou no menu',
            step2: 'Deslize para baixo no menu que abre',
            step3: 'Toque em "Adicionar ao Ecrã Principal"',
            step4: 'Toque em "Adicionar" no canto superior para terminar'
        }
    }
};
